(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(26727);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_PageSection; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3411);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(33080);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(5406);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(76636);
// EXTERNAL MODULE: ./src/components/PageSection/svg/CurvedSvg.tsx
var CurvedSvg = __webpack_require__(17678);
;// CONCATENATED MODULE: ./src/components/PageSection/CurvedDivider.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  z-index: ",
        ";\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: ",
        ";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a6e052-0"
})(_templateObject(), function(param) {
    var theme = param.theme, dividerFill = param.dividerFill;
    if (theme.isDark) {
        return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || "none";
    }
    return (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.light) || (dividerFill === null || dividerFill === void 0 ? void 0 : dividerFill.dark) || "none";
}, function(param) {
    var index = param.index;
    return index;
});
var ComponentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-82a6e052-1"
})(_templateObject1(), function(param) {
    var index = param.index;
    return index + 1;
});
var CurvedDivider = function(param) {
    var index = param.index, dividerPosition = param.dividerPosition, dividerComponent = param.dividerComponent, concave = param.concave, clipFill = param.clipFill, dividerFill = param.dividerFill;
    var showConvexTop = dividerPosition === "top" && !concave;
    var showConvexBottom = dividerPosition === "bottom" && !concave;
    var showConcaveTop = dividerPosition === "top" && concave;
    var showConcaveBottom = dividerPosition === "bottom" && concave;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        index: index,
        dividerFill: dividerFill,
        children: [
            dividerComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(ComponentWrapper, {
                index: index,
                children: dividerComponent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showConcaveTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConcaveTop */.n6, {
                        clipFill: clipFill
                    }),
                    showConcaveBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConcaveBottom */.CT, {
                        clipFill: clipFill
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    showConvexTop && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConvexTop */.Z5, {
                        clipFill: clipFill
                    }),
                    showConvexBottom && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurvedSvg/* ConvexBottom */.kZ, {
                        clipFill: clipFill
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var PageSection_CurvedDivider = (CurvedDivider);

;// CONCATENATED MODULE: ./src/components/PageSection/index.tsx




function PageSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  flex-direction: column;\n  align-items: center;\n  z-index: ",
        ";\n  padding: ",
        ";\n"
    ]);
    PageSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: auto;\n  padding-top: 16px;\n  padding-bottom: 16px;\n\n  ",
        " {\n    padding-top: 32px;\n    padding-bottom: 32px;\n  }\n\n  ",
        " {\n    padding-top: 48px;\n    padding-bottom: 48px;\n  }\n"
    ]);
    PageSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var BackgroundColor = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    className: "page-bg"
}).withConfig({
    componentId: "sc-308e1ef1-0"
})(PageSection_templateObject(), function(param) {
    var index = param.index;
    return index - 1;
}, function(param) {
    var padding = param.padding;
    return padding;
});
var ChildrenWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-308e1ef1-1"
})(PageSection_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PageSection = function(_param) {
    var children = _param.children, svgFill = _param.svgFill, _param_index = _param.index, index = _param_index === void 0 ? 1 : _param_index, dividerComponent = _param.dividerComponent, _param_dividerPosition = _param.dividerPosition, dividerPosition = _param_dividerPosition === void 0 ? "bottom" : _param_dividerPosition, _param_hasCurvedDivider = _param.hasCurvedDivider, hasCurvedDivider = _param_hasCurvedDivider === void 0 ? true : _param_hasCurvedDivider, _param_concaveDivider = _param.concaveDivider, concaveDivider = _param_concaveDivider === void 0 ? false : _param_concaveDivider, clipFill = _param.clipFill, dividerFill = _param.dividerFill, containerProps = _param.containerProps, innerProps = _param.innerProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "svgFill",
        "index",
        "dividerComponent",
        "dividerPosition",
        "hasCurvedDivider",
        "concaveDivider",
        "clipFill",
        "dividerFill",
        "containerProps",
        "innerProps"
    ]);
    var padding = (0,react.useMemo)(function() {
        // No curved divider
        if (!hasCurvedDivider) {
            return "48px 0";
        }
        // Bottom curved divider
        // Less bottom padding, as the divider is present there
        if (dividerPosition === "bottom") {
            return "48px 0 14px";
        }
        // Top curved divider
        // Less top padding, as the divider is present there
        if (dividerPosition === "top") {
            return "14px 0 48px";
        }
        return "48px 0";
    }, [
        dividerPosition,
        hasCurvedDivider
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.ZP, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, containerProps), {
        children: [
            hasCurvedDivider && dividerPosition === "top" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundColor, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                index: index,
                padding: padding
            }, props), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChildrenWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, innerProps), {
                    children: children
                }))
            })),
            hasCurvedDivider && dividerPosition === "bottom" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection_CurvedDivider, {
                svgFill: svgFill,
                index: index,
                concave: concaveDivider,
                dividerPosition: dividerPosition,
                dividerComponent: dividerComponent,
                clipFill: clipFill,
                dividerFill: dividerFill
            })
        ]
    }));
};
/* harmony default export */ var components_PageSection = (PageSection);


/***/ }),

/***/ 17678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ ConcaveBottom; },
/* harmony export */   "Z5": function() { return /* binding */ ConvexTop; },
/* harmony export */   "kZ": function() { return /* binding */ ConvexBottom; },
/* harmony export */   "n6": function() { return /* binding */ ConcaveTop; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3411);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5406);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 20px;\n  clip-path: url(",
        ");\n\n  background: ",
        ";\n\n  & svg {\n    display: block;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  transform: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var sharedStyles = function(theme, clipPath, clipFill) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), clipPath, function() {
        if (theme.isDark) {
            return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.dark) || (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
        }
        return (clipFill === null || clipFill === void 0 ? void 0 : clipFill.light) || theme.colors.background;
    });
};
var ConcaveContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-f0d6319c-0"
})(_templateObject1(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConcaveCurve" ? "translate(0, -13px)" : "translate(0, 1px)";
});
var ConvexContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP).withConfig({
    componentId: "sc-f0d6319c-1"
})(_templateObject2(), function(param) {
    var theme = param.theme, clipPath = param.clipPath, clipFill = param.clipFill;
    return sharedStyles(theme, clipPath, clipFill);
}, function(param) {
    var clipPath = param.clipPath;
    return clipPath === "#bottomConvexCurve" ? "translate(0, -13px)" : "translate(0, -1px)";
});
var ConvexTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#topConvexCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "topConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C 0.75 0, .25 0, 0 1 Z"
                    })
                })
            })
        })
    });
};
var ConvexBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConvexContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConvexCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "bottomConvexCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveTop = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#topConcaveCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "topConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,0 L 0,1 L 1,1 L 1,0 C .75 1, .25 1, 0 0 Z"
                    })
                })
            })
        })
    });
};
var ConcaveBottom = function(param) {
    var clipFill = param.clipFill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ConcaveContainer, {
        clipFill: clipFill,
        clipPath: "#bottomConcaveCurve",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
            width: "0",
            height: "0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("clipPath", {
                    id: "bottomConcaveCurve",
                    clipPathUnits: "objectBoundingBox",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M 0,1 L 0,0 L 1,0 L 1,1 C .75 0.1, .25 0.1, 0 1 Z"
                    })
                })
            })
        })
    });
};


/***/ }),

/***/ 32331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16775);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3411);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  bottom: 0px;\n  position: absolute;\n  right: 0px;\n  min-width: 20px;\n  min-height: 20px;\n  width: 37.5%;\n  height: 37.5%;\n  z-index: 5;\n\n  ",
        " {\n    border-width: 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: url('",
        "');\n  background-repeat: no-repeat;\n  background-size: cover;\n  border-radius: 50%;\n  position: relative;\n  width: 100%;\n  height: 100%;\n\n  & > img {\n    border-radius: 50%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var TeamAvatar = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-c5c8ef7c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var AvatarWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c5c8ef7c-1"
})(_templateObject1(), function(param) {
    var bg = param.bg;
    return bg;
});
// TODO: replace with no profile avatar icon
var AvatarInactive = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c5c8ef7c-2"
})(_templateObject2());
var ProfileAvatarWithTeam = function(param) {
    var profile = param.profile;
    var _profile_nft;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(AvatarWrapper, {
        bg: (_profile_nft = profile.nft) === null || _profile_nft === void 0 ? void 0 : _profile_nft.image.thumbnail,
        children: [
            !profile.isActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AvatarInactive, {}),
            profile.team && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TeamAvatar, {
                src: "/images/teams/".concat(profile.team.images.alt),
                alt: profile.team.name
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProfileAvatarWithTeam);


/***/ }),

/***/ 85264:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87394);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38497);


var useGetUsernameWithVisibility = function(profile) {
    var _useUserUsernameVisibility = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,state_user_hooks__WEBPACK_IMPORTED_MODULE_0__/* .useUserUsernameVisibility */ .Pn)(), 2), userUsernameVisibility = _useUserUsernameVisibility[0], setUserUsernameVisibility = _useUserUsernameVisibility[1];
    return {
        usernameWithVisibility: (profile === null || profile === void 0 ? void 0 : profile.username) && (userUsernameVisibility ? profile === null || profile === void 0 ? void 0 : profile.username : "\uD83D\uDC30\uD83D\uDC30\uD83D\uDC30\uD83D\uDC30\uD83D\uDC30\uD83D\uDC30"),
        userUsernameVisibility: userUsernameVisibility,
        setUserUsernameVisibility: setUserUsernameVisibility
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetUsernameWithVisibility);


/***/ }),

/***/ 3024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useVaultApy; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(87394);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5163);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(10528);
/* harmony import */ var _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49222);
/* harmony import */ var _ethersproject_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90711);
/* harmony import */ var lodash_toString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66188);
/* harmony import */ var lodash_toString__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_toString__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16816);
/* harmony import */ var config_abi_masterchef_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84951);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var state_pools_hooks__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72239);
/* harmony import */ var swr_immutable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2303);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81254);
/* harmony import */ var _pancakeswap_utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39241);
/* harmony import */ var config_constants_pools__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27717);
/* harmony import */ var _utils_multicall__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(60242);















var masterChefAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getMasterChefAddress */ .Oc)();
// default
var DEFAULT_PERFORMANCE_FEE_DECIMALS = 2;
var PRECISION_FACTOR = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_10__/* .BigNumber.from */ .O$.from("1000000000000");
var getFlexibleApy = function(totalCakePoolEmissionPerYear, pricePerFullShare, totalShares) {
    return totalCakePoolEmissionPerYear.mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(_ethersproject_constants__WEBPACK_IMPORTED_MODULE_12__/* .WeiPerEther */ .Ce)).divUnsafe(pricePerFullShare).divUnsafe(totalShares).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(100));
};
var _getBoostFactor = function(boostWeight, duration, durationFactor) {
    return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(boostWeight).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(Math.max(duration, 0))).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(durationFactor)).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(PRECISION_FACTOR));
};
var getLockedApy = function(flexibleApy, boostFactor) {
    return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(flexibleApy).mulUnsafe(boostFactor.addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from("1")));
};
var cakePoolPID = 0;
function useVaultApy() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? config_constants_pools__WEBPACK_IMPORTED_MODULE_8__/* .MAX_LOCK_DURATION */ .VO : _ref_duration;
    var _useCakeVault = (0,state_pools_hooks__WEBPACK_IMPORTED_MODULE_4__/* .useCakeVault */ .Xo)(), _useCakeVault_totalShares = _useCakeVault.totalShares, totalShares = _useCakeVault_totalShares === void 0 ? _pancakeswap_utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__/* .BIG_ZERO */ .HW : _useCakeVault_totalShares, _useCakeVault_pricePerFullShare = _useCakeVault.pricePerFullShare, pricePerFullShare = _useCakeVault_pricePerFullShare === void 0 ? _pancakeswap_utils_bigNumber__WEBPACK_IMPORTED_MODULE_7__/* .BIG_ZERO */ .HW : _useCakeVault_pricePerFullShare, tmp = _useCakeVault.fees, performanceFeeAsDecimal = (tmp === void 0 ? {
        performanceFeeAsDecimal: DEFAULT_PERFORMANCE_FEE_DECIMALS
    } : tmp).performanceFeeAsDecimal;
    var totalSharesAsEtherBN = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(totalShares.toString());
    }, [
        totalShares
    ]);
    var pricePerFullShareAsEtherBN = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(pricePerFullShare.toString());
    }, [
        pricePerFullShare
    ]);
    var _useSWRImmutable = (0,swr_immutable__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("masterChef-total-cake-pool-emission", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(function() {
        var calls, _ref, _ref_, specialFarmsPerBlock, cakePoolInfo, _ref_1, totalSpecialAllocPoint, cakePoolSharesInSpecialFarms;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_14__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    calls = [
                        {
                            address: masterChefAddress,
                            name: "cakePerBlock",
                            params: [
                                false
                            ]
                        },
                        {
                            address: masterChefAddress,
                            name: "poolInfo",
                            params: [
                                cakePoolPID
                            ]
                        },
                        {
                            address: masterChefAddress,
                            name: "totalSpecialAllocPoint"
                        }
                    ];
                    return [
                        4,
                        (0,_utils_multicall__WEBPACK_IMPORTED_MODULE_9__/* .multicallv2 */ .vf)({
                            abi: config_abi_masterchef_json__WEBPACK_IMPORTED_MODULE_2__,
                            calls: calls
                        })
                    ];
                case 1:
                    _ref = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"].apply */ .Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), _ref_ = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_ref[0], 1), specialFarmsPerBlock = _ref_[0], cakePoolInfo = _ref[1], _ref_1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_ref[2], 1), totalSpecialAllocPoint = _ref_1[0];
                    cakePoolSharesInSpecialFarms = _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(cakePoolInfo.allocPoint).divUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(totalSpecialAllocPoint));
                    return [
                        2,
                        _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(specialFarmsPerBlock).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(config__WEBPACK_IMPORTED_MODULE_1__/* .BLOCKS_PER_YEAR */ .Bi)).mulUnsafe(cakePoolSharesInSpecialFarms)
                    ];
            }
        });
    })), totalCakePoolEmissionPerYear = _useSWRImmutable.data;
    var flexibleApy = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return totalCakePoolEmissionPerYear && !pricePerFullShareAsEtherBN.isZero() && !totalSharesAsEtherBN.isZero() && getFlexibleApy(totalCakePoolEmissionPerYear, pricePerFullShareAsEtherBN, totalSharesAsEtherBN).toString();
    }, [
        pricePerFullShareAsEtherBN,
        totalCakePoolEmissionPerYear,
        totalSharesAsEtherBN
    ]);
    var boostFactor = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return _getBoostFactor(config_constants_pools__WEBPACK_IMPORTED_MODULE_8__/* .BOOST_WEIGHT */ .xt, duration, config_constants_pools__WEBPACK_IMPORTED_MODULE_8__/* .DURATION_FACTOR */ .A0);
    }, [
        duration
    ]);
    var lockedApy = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return flexibleApy && getLockedApy(flexibleApy, boostFactor).toString();
    }, [
        boostFactor,
        flexibleApy
    ]);
    var getBoostFactor = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(adjustDuration) {
        return _getBoostFactor(config_constants_pools__WEBPACK_IMPORTED_MODULE_8__/* .BOOST_WEIGHT */ .xt, adjustDuration, config_constants_pools__WEBPACK_IMPORTED_MODULE_8__/* .DURATION_FACTOR */ .A0);
    }, []);
    var flexibleApyNoFee = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (flexibleApy && performanceFeeAsDecimal) {
            var rewardPercentageNoFee = lodash_toString__WEBPACK_IMPORTED_MODULE_0___default()(1 - performanceFeeAsDecimal / 100);
            return _ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(flexibleApy).mulUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from(rewardPercentageNoFee)).toString();
        }
        return flexibleApy;
    }, [
        flexibleApy,
        performanceFeeAsDecimal
    ]);
    return {
        flexibleApy: flexibleApyNoFee,
        lockedApy: lockedApy,
        getLockedApy: (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(adjustDuration) {
            return flexibleApy && getLockedApy(flexibleApy, getBoostFactor(adjustDuration)).toString();
        }, [
            flexibleApy,
            getBoostFactor
        ]),
        boostFactor: (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
            return boostFactor.addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from("1"));
        }, [
            boostFactor
        ]),
        getBoostFactor: (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(adjustDuration) {
            return getBoostFactor(adjustDuration).addUnsafe(_ethersproject_bignumber__WEBPACK_IMPORTED_MODULE_11__/* .FixedNumber.from */ .xs.from("1"));
        }, [
            getBoostFactor
        ])
    };
}


/***/ }),

/***/ 26727:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/swr/core/dist/index.mjs
var dist = __webpack_require__(3255);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-jsx/style.js
var style = __webpack_require__(70784);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3411);
// EXTERNAL MODULE: ./src/components/PageSection/index.tsx + 1 modules
var PageSection = __webpack_require__(88987);
// EXTERNAL MODULE: ../../node_modules/wagmi/dist/index.js + 25 modules
var wagmi_dist = __webpack_require__(78743);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(84252);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(76636);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(42617);
// EXTERNAL MODULE: ../../packages/localization/src/index.tsx + 6 modules
var src = __webpack_require__(73921);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(15112);
// EXTERNAL MODULE: ../../packages/swap-sdk/dist/index.mjs + 1 modules
var swap_sdk_dist = __webpack_require__(72027);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(33080);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(87016);
// EXTERNAL MODULE: ../../packages/uikit/src/components/NextLink/NextLink.tsx
var NextLink = __webpack_require__(97712);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(68303);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(95457);
// EXTERNAL MODULE: ../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(38421);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/home/lunar-bunny/pngwing.com.png
/* harmony default export */ var pngwing_com = ({"src":"/_next/static/media/pngwing.com.dadbd0b4.png","height":1000,"width":1000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAZlBMVEVMaXH/vTOkiDOXPy+WhzqmeDSDMzKwlD+lmkWqjTV+QyudhTuKTTJ/PDy1jzV5KSmnZSjGoCvCeSGdFh5hOCPSukC2tm0WVjKIej5fQSlRKhh6Tii8li5wbiS6aCrlx052RCiAQS5XfLCVAAAAHnRSTlMABbJ2jDhxUDkgl/72JmVDfpHUnV73B1t73XG/4/TxonVOAAAACXBIWXMAAAsSAAALEgHS3X78AAAAQElEQVR4nAXBhQGAMBAAsat+DXeH/ZckARj3MIOKqbyHRMSm8m02oETnfC1Q2+6ZzhVccP1tgkDUZmgFoPKNhx9pBAKytnWv6AAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(5406);
;// CONCATENATED MODULE: ./src/views/Home/components/CompositeImage.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(",
        ", ",
        ");\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-height: ",
        ";\n\n  & :nth-child(2) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n\n  & :nth-child(5) {\n    animation: ",
        " 3s ease-in-out infinite;\n    animation-delay: 0s;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: ",
        ";\n  visibility: hidden;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  img {\n    max-height: 100%;\n    width: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var floatingAnim = function(x, y) {
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject(), x, y);
};
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.ZP).withConfig({
    componentId: "sc-dd92527b-0"
})(_templateObject1(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
}, floatingAnim("3px", "15px"), floatingAnim("5px", "10px"), floatingAnim("6px", "5px"), floatingAnim("4px", "12px"));
var DummyImg = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-dd92527b-1"
})(_templateObject2(), function(param) {
    var maxHeight = param.maxHeight;
    return maxHeight;
});
var ImageWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.ZP).withConfig({
    componentId: "sc-dd92527b-2"
})(_templateObject3());
var Resolution;
(function(Resolution) {
    Resolution["MD"] = "1.5x";
    Resolution["LG"] = "2x";
})(Resolution || (Resolution = {}));
var getImageUrl = function(base, imageSrc, resolution) {
    var extension = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".png";
    return "".concat(base).concat(imageSrc).concat(resolution ? "@".concat(resolution).concat(extension) : extension);
};
var getSrcSet = function(base, imageSrc) {
    var extension = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".png";
    return "".concat(getImageUrl(base, imageSrc, undefined, extension), " 512w,\n  ").concat(getImageUrl(base, imageSrc, Resolution.MD, extension), " 768w,\n  ").concat(getImageUrl(base, imageSrc, Resolution.LG, extension), " 1024w,");
};
var CompositeImage = function(param) {
    var path = param.path, attributes = param.attributes, _param_maxHeight = param.maxHeight, maxHeight = _param_maxHeight === void 0 ? "512px" : _param_maxHeight;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        maxHeight: maxHeight,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DummyImg, {
                srcSet: getSrcSet(path, attributes[0].src, ".webp"),
                maxHeight: maxHeight,
                loading: "lazy",
                decoding: "async",
                onError: function(e) {
                    var fallbackSrcSet = getSrcSet(path, attributes[0].src);
                    if (e.currentTarget.srcset !== "" && e.currentTarget.srcset !== fallbackSrcSet) {
                        // eslint-disable-next-line no-param-reassign
                        e.currentTarget.srcset = fallbackSrcSet;
                    } else {
                        var fallbackSrc = getImageUrl(path, attributes[0].src);
                        if (e.currentTarget.srcset !== "" && !e.currentTarget.src.endsWith(fallbackSrc)) {
                            // eslint-disable-next-line no-param-reassign
                            e.currentTarget.srcset = "";
                            // eslint-disable-next-line no-param-reassign
                            e.currentTarget.src = fallbackSrc;
                        }
                    }
                }
            }),
            attributes.map(function(image) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        srcSet: getSrcSet(path, image.src, ".webp"),
                        alt: image.alt,
                        onError: function(e) {
                            var fallbackSrcSet = getSrcSet(path, image.src);
                            if (e.currentTarget.srcset !== "" && e.currentTarget.srcset !== fallbackSrcSet) {
                                // eslint-disable-next-line no-param-reassign
                                e.currentTarget.srcset = fallbackSrcSet;
                            } else {
                                var fallbackSrc = getImageUrl(path, image.src);
                                if (e.currentTarget.srcset !== "" && !e.currentTarget.src.endsWith(fallbackSrc)) {
                                    // eslint-disable-next-line no-param-reassign
                                    e.currentTarget.srcset = "";
                                    // eslint-disable-next-line no-param-reassign
                                    e.currentTarget.src = fallbackSrc;
                                }
                            }
                        }
                    })
                }, image.src);
            })
        ]
    });
};
/* harmony default export */ var components_CompositeImage = (CompositeImage);

// EXTERNAL MODULE: ./src/views/Home/components/SlideSvg.tsx
var SlideSvg = __webpack_require__(2076);
;// CONCATENATED MODULE: ./src/views/Home/components/Hero.tsx


function Hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(-5px, -5px);\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    Hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0.9;\n  }\n  50% {\n    opacity: 0.1;\n  }\n  to {\n    opacity: 0.9;\n  }\n"
    ]);
    Hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Hero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  bottom: 0px;\n  left: 0px;\n"
    ]);
    Hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Hero_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  bottom: -3px;\n"
    ]);
    Hero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  animation: ",
        " 3.5s ease-in-out infinite;\n  will-change: transform;\n  > span {\n    overflow: visible !important; // make sure the next-image pre-build blur image not be cropped\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  & :nth-child(2) {\n    animation: ",
        " 2s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 5s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 2.5s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}











var flyingAnim = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(Hero_templateObject());
};
var fading = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(Hero_templateObject1());
};
var BgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4190359a-0"
})(Hero_templateObject2());
var InnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4190359a-1"
})(Hero_templateObject3());
var BunnyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4190359a-2"
})(_templateObject4(), flyingAnim);
var StarsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4190359a-3"
})(_templateObject5(), fading, fading, fading);
var starsImage = {
    path: "/images/home/lunar-bunny/",
    attributes: [
        {
            src: "star-l",
            alt: "3D Star"
        },
        {
            src: "star-r",
            alt: "3D Star"
        },
        {
            src: "star-top-r",
            alt: "3D Star"
        }
    ]
};
var Hero = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var _useAccount = (0,wagmi_dist/* useAccount */.mA)(), account = _useAccount.address;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,jsx_runtime.jsx)((style_default()), {
                id: "17b87fe7f0af5ff",
                children: '.slide-svg-dark{display:none}.slide-svg-light{display:block}[data-theme="dark"] .slide-svg-dark{display:block}[data-theme="dark"] .slide-svg-light{display:none}'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InnerWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideSvg/* SlideSvgDark */.U, {
                            className: "slide-svg-dark",
                            width: "100%"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SlideSvg/* SlideSvgLight */.s, {
                            className: "slide-svg-light",
                            width: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                position: "relative",
                flexDirection: [
                    "column-reverse",
                    null,
                    null,
                    "row"
                ],
                alignItems: [
                    "flex-end",
                    null,
                    null,
                    "center"
                ],
                justifyContent: "center",
                mt: [
                    account ? "280px" : "50px",
                    null,
                    0
                ],
                id: "homepage-hero",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "1",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "xxl",
                                color: "secondary",
                                mb: "24px",
                                children: t("Swap like pro at mangoswapp")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "md",
                                mb: "24px",
                                children: t("Trade, earn, and win crypto on the most popular decentralized platform in the galaxy.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                children: [
                                    !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                                        mr: "8px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        to: "/swap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: !account ? "secondary" : "primary",
                                            children: t("Trade Now")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        height: [
                            "192px",
                            null,
                            null,
                            "100%"
                        ],
                        width: [
                            "192px",
                            null,
                            null,
                            "100%"
                        ],
                        flex: [
                            null,
                            null,
                            null,
                            "1"
                        ],
                        mb: [
                            "24px",
                            null,
                            null,
                            "0"
                        ],
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BunnyWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: pngwing_com,
                                    priority: true,
                                    placeholder: "blur",
                                    alt: t("Lunar bunny")
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,src_object_spread/* default */.Z)({}, starsImage))
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Hero = (Hero);

;// CONCATENATED MODULE: ./src/views/Home/components/SalesSection/data.ts
var swapSectionData = function(t) {
    return {
        headingText: t("Trade anything. No registration, no hassle."),
        bodyText: t("Trade any token on BNB Smart Chain in seconds, just by connecting your wallet."),
        reverse: false,
        primaryButton: {
            to: "/swap",
            text: t("Trade Now"),
            external: false
        },
        secondaryButton: {
            to: "#",
            text: t("Learn"),
            external: true
        },
        images: {
            path: "/images/home/trade/",
            attributes: [
                {
                    src: "BNB",
                    alt: t("BNB token")
                },
                {
                    src: "BTC",
                    alt: t("BTC token")
                }
            ]
        }
    };
};
var earnSectionData = function(t) {
    return {
        headingText: t("Earn passive income with crypto."),
        bodyText: t("mangoswapp makes it easy to make your crypto work for you."),
        reverse: true,
        primaryButton: {
            to: "/farms",
            text: t("Explore"),
            external: false
        },
        secondaryButton: {
            to: "#",
            text: t("Learn"),
            external: true
        },
        images: {
            path: "/images/home/earn/",
            attributes: [
                {
                    src: "pie",
                    alt: t("Pie chart")
                },
                {
                    src: "stonks",
                    alt: t("Stocks chart")
                }
            ]
        }
    };
};
var cakeSectionData = function(t) {
    return {
        headingText: t("CAKE makes our world go round."),
        bodyText: t("CAKE token is at the heart of the PancakeSwap ecosystem. Buy it, win it, farm it, spend it, stake it... heck, you can even vote with it!"),
        reverse: false,
        primaryButton: {
            to: "/swap?outputCurrency=0x0e09fabb73bd3ade0a17ecc321fd13a19e81ce82&chainId=56",
            text: t("Buy CAKE"),
            external: false
        },
        secondaryButton: {
            to: "#",
            text: t("Learn"),
            external: true
        },
        images: {
            path: "/images/home/cake/",
            attributes: [
                // { src: 'bottom-right', alt: t('Small 3d pancake') },
                {
                    src: "top-right",
                    alt: t("Small 3d pancake")
                }
            ]
        }
    };
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/Community.tsx
var Community = __webpack_require__(17163);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/Swap.tsx
var Swap = __webpack_require__(38230);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/Chart.tsx
var Chart = __webpack_require__(11335);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(32301);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(11982);
// EXTERNAL MODULE: ../../packages/utils/formatBalance.ts
var formatBalance = __webpack_require__(32288);
// EXTERNAL MODULE: ../../node_modules/swr/immutable/dist/index.mjs
var immutable_dist = __webpack_require__(2303);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Card/Card.tsx + 1 modules
var Card = __webpack_require__(80751);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Card/CardBody.tsx
var CardBody = __webpack_require__(40125);
;// CONCATENATED MODULE: ./src/views/Home/components/IconCard.tsx




function IconCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: fit-content;\n  padding: 1px 1px 4px 1px;\n  box-sizing: border-box;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    IconCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IconCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 24px;\n  right: 24px;\n\n  ",
        " {\n    ",
        "\n  }\n"
    ]);
    IconCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-dafe503b-0"
})(IconCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var rotation = param.rotation;
    return rotation ? "transform: rotate(".concat(rotation, ");") : "";
});
var IconWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.ZP).withConfig({
    componentId: "sc-dafe503b-1"
})(IconCard_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var rotation = param.rotation;
    return rotation ? "transform: rotate(".concat(rotation, ");") : "";
});
var IconCard = function(_param) {
    var icon = _param.icon, background = _param.background, borderColor = _param.borderColor, rotation = _param.rotation, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon",
        "background",
        "borderColor",
        "rotation",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        background: background,
        borderBackground: borderColor,
        rotation: rotation
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardBody/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconWrapper, {
                    rotation: rotation,
                    children: icon
                }),
                children
            ]
        })
    }));
};
/* harmony default export */ var components_IconCard = (IconCard);

// EXTERNAL MODULE: ../../packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(20870);
;// CONCATENATED MODULE: ./src/views/Home/components/MetricsSection/StatCardContent.tsx


var StatCardContent = function(param) {
    var headingText = param.headingText, bodyText = param.bodyText, highlightColor = param.highlightColor;
    var _useMatchBreakpoints = (0,useMatchBreakpoints/* default */.Z)(), isMobile = _useMatchBreakpoints.isMobile, isTablet = _useMatchBreakpoints.isTablet;
    var isSmallerScreen = isMobile || isTablet;
    var split = headingText.split(" ");
    var lastWord = split.pop();
    var remainingWords = split.slice(0, split.length).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        minHeight: [
            null,
            null,
            null,
            "168px"
        ],
        minWidth: "232px",
        width: "fit-content",
        flexDirection: "column",
        justifyContent: "flex-end",
        mt: [
            null,
            null,
            null,
            "64px"
        ],
        children: [
            isSmallerScreen && remainingWords.length > 13 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "lg",
                children: remainingWords
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                scale: "xl",
                children: remainingWords
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                color: highlightColor,
                scale: "xl",
                mb: "24px",
                children: lastWord
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                color: "textSubtle",
                children: bodyText
            })
        ]
    });
};
/* harmony default export */ var MetricsSection_StatCardContent = (StatCardContent);

;// CONCATENATED MODULE: ./src/views/Home/components/GradientLogoSvg.tsx

var GradientLogo = function(props) {
    return(// <Svg viewBox="0 0 48 48" {...props}>
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M14.9024 0C10.8947 0 7.87179 3.60289 8.60749 7.50271L10.3484 16.7306C4.45101 19.3061 0 23.7533 0 29.3333V32.7273C0 37.3405 3.08306 41.2029 7.39317 43.8102C11.7369 46.4379 17.6132 48 24 48C30.3868 48 36.2631 46.4379 40.6068 43.8102C44.9169 41.2029 48 37.3405 48 32.7273V29.3333C48 23.7236 43.5028 19.2593 37.5552 16.6889L39.2882 7.50271C40.0239 3.6029 37.001 0 32.9933 0C29.4567 0 26.5896 2.83809 26.5896 6.33904V14.147C25.7386 14.0899 24.8746 14.0606 24 14.0606C23.0897 14.0606 22.1908 14.0923 21.3061 14.1541V6.33904C21.3061 2.83809 18.4391 0 14.9024 0ZM17.8776 28.3637C17.8776 30.372 16.7811 32 15.4286 32C14.0761 32 12.9796 30.372 12.9796 28.3637C12.9796 26.3554 14.0761 24.7273 15.4286 24.7273C16.7811 24.7273 17.8776 26.3554 17.8776 28.3637ZM34.7757 28.3637C34.7757 30.372 33.6792 32 32.3267 32C30.9742 32 29.8777 30.372 29.8777 28.3637C29.8777 26.3554 30.9742 24.7273 32.3267 24.7273C33.6792 24.7273 34.7757 26.3554 34.7757 28.3637Z"
    //     fill="url(#paint0_linear)"
    //   />
    //   <defs>
    //     <linearGradient id="paint0_linear" x1="24" y1="0" x2="24" y2="48" gradientUnits="userSpaceOnUse">
    //       <stop stopColor="#a1b121" />
    //       <stop offset="1" stopColor="#5121B1" />
    //     </linearGradient>
    //   </defs>
    // </Svg>
    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
};
/* harmony default export */ var GradientLogoSvg = (GradientLogo);

;// CONCATENATED MODULE: ./src/views/Home/components/MetricsSection/index.tsx












var Stats = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var _useSWRImmutable = (0,immutable_dist/* default */.Z)("tvl"), tvl = _useSWRImmutable.data;
    var _useSWRImmutable1 = (0,immutable_dist/* default */.Z)("totalTx30Days"), txCount = _useSWRImmutable1.data;
    var _useSWRImmutable2 = (0,immutable_dist/* default */.Z)("addressCount30Days"), addressCount = _useSWRImmutable2.data;
    var trades = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(txCount);
    var users = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(addressCount);
    var tvlString = tvl ? (0,formatBalance/* formatLocalisedCompactNumber */.uI)(tvl) : "-";
    var tvlText = t("And those users are now entrusting the platform with over $%tvl% in funds.", {
        tvl: tvlString
    });
    var _tvlText_split = (0,_sliced_to_array/* default */.Z)(tvlText.split(tvlString), 2), entrusting = _tvlText_split[0], inFunds = _tvlText_split[1];
    var UsersCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Community/* default */.Z, {
            color: "secondary",
            width: "36px"
        })
    };
    var TradesCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Swap/* default */.Z, {
            color: "primary",
            width: "36px"
        })
    };
    var StakedCardData = {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Chart/* default */.Z, {
            color: "failure",
            width: "36px"
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        style: {
            display: "none"
        },
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GradientLogoSvg, {
                height: "48px",
                width: "48px",
                mb: "24px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xl",
                children: t("Used by millions.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                textAlign: "center",
                scale: "xl",
                mb: "32px",
                children: t("Trusted with billions.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                textAlign: "center",
                color: "textSubtle",
                children: t("PancakeSwap has the most users of any decentralized platform, ever.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flexWrap: "wrap",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    display: "inline",
                    textAlign: "center",
                    color: "textSubtle",
                    mb: "20px",
                    children: [
                        entrusting,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: tvl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: tvlString
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                display: "inline-block",
                                height: 16,
                                width: 70,
                                mt: "2px"
                            })
                        }),
                        inFunds
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                textAlign: "center",
                color: "textSubtle",
                bold: true,
                mb: "32px",
                children: t("Will you join them?")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, UsersCardData), {
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            null,
                            null,
                            "0"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                            headingText: t("%users% users", {
                                users: users
                            }),
                            bodyText: t("in the last 30 days"),
                            highlightColor: theme.colors.secondary
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, TradesCardData), {
                        mr: [
                            null,
                            null,
                            null,
                            "16px"
                        ],
                        mb: [
                            "16px",
                            null,
                            null,
                            "0"
                        ],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                            headingText: t("%trades% trades", {
                                trades: trades
                            }),
                            bodyText: t("made in the last 30 days"),
                            highlightColor: theme.colors.primary
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, StakedCardData), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection_StatCardContent, {
                            headingText: t("$%tvl% staked", {
                                tvl: tvlString
                            }),
                            bodyText: t("Total Value Locked"),
                            highlightColor: theme.colors.failure
                        })
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ var MetricsSection = (Stats);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(91928);
// EXTERNAL MODULE: ./src/views/Home/components/ColoredWordHeading.tsx
var ColoredWordHeading = __webpack_require__(71446);
;// CONCATENATED MODULE: ./src/views/Home/components/SalesSection/index.tsx





var SalesSection = function(props) {
    var headingText = props.headingText, bodyText = props.bodyText, reverse = props.reverse, primaryButton = props.primaryButton, secondaryButton = props.secondaryButton, images = props.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexDirection: "column",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: [
                "column-reverse",
                null,
                null,
                reverse ? "row-reverse" : "row"
            ],
            alignItems: [
                "flex-end",
                null,
                null,
                "center"
            ],
            justifyContent: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    flex: "1",
                    ml: [
                        null,
                        null,
                        null,
                        reverse && "64px"
                    ],
                    mr: [
                        null,
                        null,
                        null,
                        !reverse && "64px"
                    ],
                    alignSelf: [
                        "flex-start",
                        null,
                        null,
                        "center"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredWordHeading/* default */.Z, {
                            text: headingText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "textSubtle",
                            mb: "24px",
                            children: bodyText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    mr: "16px",
                                    children: primaryButton.external ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        external: true,
                                        href: primaryButton.to,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "card",
                                            bold: true,
                                            fontSize: "16px",
                                            children: primaryButton.text
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        to: primaryButton.to,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            color: "card",
                                            bold: true,
                                            fontSize: "16px",
                                            children: primaryButton.text
                                        })
                                    })
                                }),
                                secondaryButton.external ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                    external: true,
                                    href: secondaryButton.to,
                                    children: secondaryButton.text
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                    to: secondaryButton.to,
                                    children: secondaryButton.text
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    height: [
                        "192px",
                        null,
                        null,
                        "100%"
                    ],
                    width: [
                        "192px",
                        null,
                        null,
                        "100%"
                    ],
                    flex: [
                        null,
                        null,
                        null,
                        "1"
                    ],
                    mb: [
                        "24px",
                        null,
                        null,
                        "0"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,src_object_spread/* default */.Z)({}, images))
                })
            ]
        })
    });
};
/* harmony default export */ var components_SalesSection = (SalesSection);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/Predictions.tsx
var Predictions = __webpack_require__(15756);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/TicketFill.tsx
var TicketFill = __webpack_require__(61150);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/hooks/src/index.ts + 12 modules
var hooks_src = __webpack_require__(92177);
// EXTERNAL MODULE: ./src/state/predictions/helpers.ts + 6 modules
var helpers = __webpack_require__(1226);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(14024);
// EXTERNAL MODULE: ./src/utils/prices.ts
var prices = __webpack_require__(82955);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(57535);
;// CONCATENATED MODULE: ./src/views/Home/components/WinSection/PredictionCardContent.tsx


function PredictionCardContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    PredictionCardContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    componentId: "sc-3ff923-0"
})(PredictionCardContent_templateObject());
var PredictionCardHeader = function(param) {
    var preText = param.preText, won = param.won;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
        color: "#5f5c0d",
        my: "8px",
        scale: "xl",
        bold: true,
        children: [
            preText,
            won
        ]
    });
};
var PredictionCardContent = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var _useIntersectionObserver = (0,hooks_src/* useIntersectionObserver */.S1)(), observerRef = _useIntersectionObserver.observerRef, isIntersecting = _useIntersectionObserver.isIntersecting;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), loadData = _useState[0], setLoadData = _useState[1];
    var bnbBusdPrice = (0,useBUSDPrice/* useBNBBusdPrice */.Hf)({
        forceMainnet: true
    });
    var cakePriceBusd = (0,useBUSDPrice/* useCakeBusdPrice */.S9)({
        forceMainnet: true
    });
    var data = (0,dist/* default */.ZP)(loadData ? [
        "prediction",
        "tokenWon"
    ] : null, helpers/* getTotalWon */.yn, {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }).data;
    var bnbWonInUsd = (0,prices/* multiplyPriceByAmount */.a)(bnbBusdPrice, (data === null || data === void 0 ? void 0 : data.totalWonBNB) || 0);
    var cakeWonInUsd = (0,prices/* multiplyPriceByAmount */.a)(cakePriceBusd, (data === null || data === void 0 ? void 0 : data.totalWonCAKE) || 0);
    var localisedBnbUsdString = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(bnbWonInUsd + cakeWonInUsd);
    var bnbWonText = t("$%wonInUsd% in BNB + CAKE won so far", {
        wonInUsd: localisedBnbUsdString
    });
    var _bnbWonText_split = (0,_sliced_to_array/* default */.Z)(bnbWonText.split(localisedBnbUsdString), 2), pretext = _bnbWonText_split[0], wonSoFar = _bnbWonText_split[1];
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setLoadData(true);
        }
    }, [
        isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            mt: "48px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "#5f5c0d",
                    bold: true,
                    fontSize: "16px",
                    children: t("Prediction")
                }),
                bnbWonInUsd ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PredictionCardHeader, {
                    preText: pretext,
                    won: localisedBnbUsdString
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: 230,
                            height: 40,
                            my: "8px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: observerRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "#5f5c0d",
                    mb: "24px",
                    bold: true,
                    fontSize: "16px",
                    children: wonSoFar
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "#5f5c0d",
                    mb: "40px",
                    children: t("Predict the price trend of BNB or CAKE to win")
                })
            ]
        })
    });
};
/* harmony default export */ var WinSection_PredictionCardContent = (PredictionCardContent);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(5163);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Balance/Balance.tsx
var Balance = __webpack_require__(92169);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 2 modules
var hooks = __webpack_require__(2917);
// EXTERNAL MODULE: ./src/state/lottery/helpers.ts
var lottery_helpers = __webpack_require__(4225);
;// CONCATENATED MODULE: ./src/views/Home/components/WinSection/LotteryCardContent.tsx




function LotteryCardContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    LotteryCardContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LotteryCardContent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n"
    ]);
    LotteryCardContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var LotteryCardContent_StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    componentId: "sc-dfd836fe-0"
})(LotteryCardContent_templateObject());
var StyledBalance = (0,styled_components_browser_esm/* default */.ZP)(Balance/* default */.Z).withConfig({
    componentId: "sc-dfd836fe-1"
})(LotteryCardContent_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gradientGold;
});
var LotteryCardContent = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var _useIntersectionObserver = (0,hooks_src/* useIntersectionObserver */.S1)(), observerRef = _useIntersectionObserver.observerRef, isIntersecting = _useIntersectionObserver.isIntersecting;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), loadData = _useState[0], setLoadData = _useState[1];
    var cakePriceBusd = (0,hooks/* usePriceCakeBusd */.Iu)({
        forceMainnet: true
    });
    var _useSWRImmutable = (0,immutable_dist/* default */.Z)(loadData ? [
        "currentLotteryId"
    ] : null, lottery_helpers/* fetchCurrentLotteryId */.kC, {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }), currentLotteryId = _useSWRImmutable.data;
    var _useSWRImmutable1 = (0,immutable_dist/* default */.Z)(currentLotteryId ? [
        "currentLottery"
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,lottery_helpers/* fetchLottery */.JE)(currentLotteryId.toString())
            ];
        });
    }), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }), currentLottery = _useSWRImmutable1.data;
    var cakePrizesText = t("%cakePrizeInUsd% in CAKE prizes this round", {
        cakePrizeInUsd: cakePriceBusd.toString()
    });
    var _cakePrizesText_split = (0,_sliced_to_array/* default */.Z)(cakePrizesText.split(cakePriceBusd.toString()), 2), pretext = _cakePrizesText_split[0], prizesThisRound = _cakePrizesText_split[1];
    var amountCollectedInCake = currentLottery ? parseFloat(currentLottery.amountCollectedInCake) : null;
    var currentLotteryPrize = amountCollectedInCake ? cakePriceBusd.times(amountCollectedInCake) : null;
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setLoadData(true);
        }
    }, [
        isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            mt: "48px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "white",
                    bold: true,
                    fontSize: "16px",
                    children: t("Lottery")
                }),
                pretext && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "white",
                    mt: "12px",
                    bold: true,
                    fontSize: "16px",
                    children: pretext
                }),
                currentLotteryPrize && currentLotteryPrize.gt(0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalance, {
                    fontSize: "40px",
                    bold: true,
                    prefix: "$",
                    decimals: 0,
                    value: (0,formatBalance/* getBalanceAmount */.U4)(currentLotteryPrize).toNumber()
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            width: 200,
                            height: 40,
                            my: "8px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: observerRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "white",
                    mb: "24px",
                    bold: true,
                    fontSize: "16px",
                    children: prizesThisRound
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "white",
                    mb: "40px",
                    children: t("Buy tickets with CAKE, win CAKE if your numbers match")
                })
            ]
        })
    });
};
/* harmony default export */ var WinSection_LotteryCardContent = (LotteryCardContent);

;// CONCATENATED MODULE: ./src/views/Home/components/WinSection/index.tsx



function WinSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  padding: 16px;\n  border: 1px solid ",
        ";\n  box-sizing: border-box;\n  backdrop-filter: blur(12px);\n  border-radius: 72px;\n\n  ",
        " {\n    padding: 40px;\n  }\n"
    ]);
    WinSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WinSection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n"
    ]);
    WinSection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WinSection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  bottom: -64px;\n  max-width: 192px;\n\n  ",
        " {\n    max-width: 100%;\n  }\n"
    ]);
    WinSection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WinSection_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  top: -64px;\n\n  max-width: 192px;\n\n  ",
        " {\n    max-width: 100%;\n  }\n"
    ]);
    WinSection_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var TransparentFrame = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c988572e-0"
})(WinSection_templateObject(), function(param) {
    var theme = param.theme;
    return theme.isDark ? "rgba(8, 6, 11, 0.6)" : " rgba(255, 255, 255, 0.6)";
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var WinSection_BgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c988572e-1"
})(WinSection_templateObject1());
var BottomLeftImgWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c988572e-2"
})(WinSection_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var TopRightImgWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-c988572e-3"
})(WinSection_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var PredictionCardData = {
    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions/* default */.Z, {
        width: "36px",
        color: "inverseContrast"
    }),
    background: "linear-gradient(180deg, #ffb237 0%, #ffcd51 51.17%, #ffe76a 100%);",
    borderColor: "#ffb237",
    rotation: "-2.36deg"
};
var LotteryCardData = {
    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketFill/* default */.Z, {
        color: "white",
        width: "36px"
    }),
    background: " linear-gradient(180deg, #7645D9 0%, #5121B1 100%);",
    borderColor: "#eac704",
    rotation: "1.43deg"
};
var bottomLeftImage = {
    path: "/images/home/prediction-cards/",
    attributes: [
        {
            src: "bottom-left",
            alt: "CAKE card"
        },
        {
            src: "green",
            alt: "Green CAKE card with up arrow"
        },
        {
            src: "red",
            alt: "Red Cake card with down arrow"
        },
        {
            src: "top-right",
            alt: "CAKE card"
        }
    ]
};
var topRightImage = {
    path: "/images/home/lottery-balls/",
    attributes: [
        {
            src: "2",
            alt: "Lottery ball number 2"
        },
        {
            src: "4",
            alt: "Lottery ball number 4"
        },
        {
            src: "6",
            alt: "Lottery ball number 6"
        },
        {
            src: "7",
            alt: "Lottery ball number 7"
        },
        {
            src: "9",
            alt: "Lottery ball number 9"
        }
    ]
};
var WinSection = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(WinSection_BgWrapper, {
                style: {
                    display: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomLeftImgWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,src_object_spread/* default */.Z)({}, bottomLeftImage))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopRightImgWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,src_object_spread/* default */.Z)({}, topRightImage))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransparentFrame, {
                style: {
                    display: "none"
                },
                isDark: theme.isDark,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ColoredWordHeading/* default */.Z, {
                            textAlign: "center",
                            text: t("Win millions in prizes")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "textSubtle",
                            children: t("Provably fair, on-chain games.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            mb: "40px",
                            color: "textSubtle",
                            children: t("Win big with mangoswapp.")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            m: "0 auto",
                            flexDirection: [
                                "column",
                                null,
                                null,
                                "row"
                            ],
                            maxWidth: "600px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    flex: "1",
                                    maxWidth: [
                                        "275px",
                                        null,
                                        null,
                                        "100%"
                                    ],
                                    mr: [
                                        null,
                                        null,
                                        null,
                                        "24px"
                                    ],
                                    mb: [
                                        "32px",
                                        null,
                                        null,
                                        "0"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, PredictionCardData), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WinSection_PredictionCardContent, {})
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    flex: "1",
                                    maxWidth: [
                                        "275px",
                                        null,
                                        null,
                                        "100%"
                                    ],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_IconCard, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, LotteryCardData), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WinSection_LotteryCardContent, {})
                                    }))
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_WinSection = (WinSection);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(79221);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/SwapVert.tsx
var SwapVert = __webpack_require__(23407);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlag.ts + 1 modules
var useFeatureFlag = __webpack_require__(63705);
// EXTERNAL MODULE: ./src/state/index.ts + 16 modules
var state = __webpack_require__(95625);
// EXTERNAL MODULE: ./src/state/farms/index.ts
var state_farms = __webpack_require__(97013);
// EXTERNAL MODULE: ./src/utils/apr.ts + 2 modules
var apr = __webpack_require__(5730);
// EXTERNAL MODULE: ../../node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(34498);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(57647);
// EXTERNAL MODULE: ../../packages/farms/constants/index.ts
var farms_constants = __webpack_require__(1632);
;// CONCATENATED MODULE: ./src/views/Home/hooks/useGetTopFarmsByApr.tsx















var useGetTopFarmsByApr = function(isIntersecting) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var _useFarms = (0,hooks/* useFarms */.E2)(), farms = _useFarms.data, regularCakePerBlock = _useFarms.regularCakePerBlock;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(types/* FetchStatus.Idle */.iF.Idle), 2), fetchStatus = _useState[0], setFetchStatus = _useState[1];
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), fetched = _useState1[0], setFetched = _useState1[1];
    var _useState2 = (0,_sliced_to_array/* default */.Z)((0,react.useState)([
        null,
        null,
        null,
        null,
        null
    ]), 2), topFarms = _useState2[0], setTopFarms = _useState2[1];
    var cakePriceBusd = (0,hooks/* usePriceCakeBusd */.Iu)();
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var farmFlag = (0,useFeatureFlag/* useFeatureFlag */.y)(useFeatureFlag/* featureFarmApiAtom */.x);
    (0,react.useEffect)(function() {
        var fetchFarmData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var farmsConfig, activeFarms, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,farms_constants.getFarmConfig)(chainId)
                            ];
                        case 1:
                            farmsConfig = _state.sent();
                            setFetchStatus(types/* FetchStatus.Fetching */.iF.Fetching);
                            activeFarms = farmsConfig.filter(function(farm) {
                                return farm.pid !== 0;
                            });
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                4,
                                ,
                                5
                            ]);
                            return [
                                4,
                                dispatch((0,state_farms/* fetchFarmsPublicDataAsync */.eG)({
                                    pids: activeFarms.map(function(farm) {
                                        return farm.pid;
                                    }),
                                    chainId: chainId,
                                    flag: farmFlag
                                }))
                            ];
                        case 3:
                            _state.sent();
                            setFetchStatus(types/* FetchStatus.Fetched */.iF.Fetched);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            e = _state.sent();
                            console.error(e);
                            setFetchStatus(types/* FetchStatus.Failed */.iF.Failed);
                            return [
                                3,
                                5
                            ];
                        case 5:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchFarmData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isIntersecting && fetchStatus === types/* FetchStatus.Idle */.iF.Idle) {
            fetchFarmData();
        }
    }, [
        dispatch,
        setFetchStatus,
        fetchStatus,
        topFarms,
        isIntersecting,
        chainId,
        farmFlag
    ]);
    (0,react.useEffect)(function() {
        var getTopFarmsByApr = function(farmsState) {
            var farmsWithPrices = farmsState.filter(function(farm) {
                return farm.lpTotalInQuoteToken && farm.quoteTokenPriceBusd && farm.pid !== 0 && farm.multiplier && farm.multiplier !== "0X";
            });
            var farmsWithApr = farmsWithPrices.map(function(farm) {
                var totalLiquidity = farm.lpTotalInQuoteToken.times(farm.quoteTokenPriceBusd);
                var _getFarmApr = (0,apr/* getFarmApr */.yW)(chainId, farm.poolWeight, cakePriceBusd, totalLiquidity, farm.lpAddress, regularCakePerBlock), cakeRewardsApr = _getFarmApr.cakeRewardsApr, lpRewardsApr = _getFarmApr.lpRewardsApr;
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, farm), {
                    apr: cakeRewardsApr,
                    lpRewardsApr: lpRewardsApr
                });
            });
            var sortedByApr = orderBy_default()(farmsWithApr, function(farm) {
                return farm.apr + farm.lpRewardsApr;
            }, "desc");
            setTopFarms(sortedByApr.slice(0, 5));
            setFetched(true);
        };
        if (fetchStatus === types/* FetchStatus.Fetched */.iF.Fetched && !topFarms[0] && (farms === null || farms === void 0 ? void 0 : farms.length) > 0) {
            getTopFarmsByApr(farms);
        }
    }, [
        setTopFarms,
        farms,
        fetchStatus,
        cakePriceBusd,
        topFarms,
        regularCakePerBlock,
        chainId
    ]);
    return {
        topFarms: topFarms,
        fetched: fetched
    };
};
/* harmony default export */ var hooks_useGetTopFarmsByApr = (useGetTopFarmsByApr);

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/lodash/partition.js
var partition = __webpack_require__(96795);
var partition_default = /*#__PURE__*/__webpack_require__.n(partition);
// EXTERNAL MODULE: ./src/state/types.ts
var state_types = __webpack_require__(50071);
// EXTERNAL MODULE: ./src/state/pools/index.ts + 5 modules
var state_pools = __webpack_require__(97124);
// EXTERNAL MODULE: ./src/state/pools/hooks.ts + 1 modules
var pools_hooks = __webpack_require__(72239);
// EXTERNAL MODULE: ./src/state/block/hooks.ts
var block_hooks = __webpack_require__(98826);
;// CONCATENATED MODULE: ./src/views/Home/hooks/useGetTopPoolsByApr.tsx














var useGetTopPoolsByApr = function(isIntersecting) {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(types/* FetchStatus.Idle */.iF.Idle), 2), fetchStatus = _useState[0], setFetchStatus = _useState[1];
    var _useState1 = (0,_sliced_to_array/* default */.Z)((0,react.useState)([
        null,
        null,
        null,
        null,
        null
    ]), 2), topPools = _useState1[0], setTopPools = _useState1[1];
    var initialBlock = (0,block_hooks/* useInitialBlock */.Xh)();
    var pools = (0,pools_hooks/* usePoolsWithVault */.f6)().pools;
    (0,react.useEffect)(function() {
        var fetchPoolsPublicData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setFetchStatus(types/* FetchStatus.Fetching */.iF.Fetching);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            // It should all be blocking calls since data only fetched once
                            return [
                                4,
                                Promise.all([
                                    dispatch((0,state_pools/* fetchCakeVaultFees */.HX)()),
                                    dispatch((0,state_pools/* fetchCakeVaultPublicData */.P4)()),
                                    dispatch((0,state_pools/* fetchPoolsPublicDataAsync */.ht)(initialBlock, chainId))
                                ])
                            ];
                        case 2:
                            _state.sent();
                            setFetchStatus(types/* FetchStatus.Fetched */.iF.Fetched);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            console.error(e);
                            setFetchStatus(types/* FetchStatus.Failed */.iF.Failed);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchPoolsPublicData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isIntersecting && fetchStatus === types/* FetchStatus.Idle */.iF.Idle && initialBlock > 0) {
            fetchPoolsPublicData();
        }
    }, [
        dispatch,
        setFetchStatus,
        fetchStatus,
        topPools,
        isIntersecting,
        initialBlock,
        chainId
    ]);
    (0,react.useEffect)(function() {
        var _partition = (0,_sliced_to_array/* default */.Z)(partition_default()(pools, function(pool) {
            return pool.sousId === 0;
        }), 2), cakePools = _partition[0], otherPools = _partition[1];
        var masterCakePool = cakePools.filter(function(cakePool) {
            return cakePool.vaultKey === state_types/* VaultKey.CakeVault */.om.CakeVault;
        });
        var getTopPoolsByApr = function(activePools) {
            var sortedByApr = orderBy_default()(activePools, function(pool) {
                return pool.apr || 0;
            }, "desc");
            setTopPools((0,_to_consumable_array/* default */.Z)(masterCakePool).concat((0,_to_consumable_array/* default */.Z)(sortedByApr.slice(0, 4))));
        };
        if (fetchStatus === types/* FetchStatus.Fetched */.iF.Fetched && !topPools[0]) {
            getTopPoolsByApr(otherPools);
        }
    }, [
        setTopPools,
        pools,
        fetchStatus,
        topPools
    ]);
    return {
        topPools: topPools
    };
};
/* harmony default export */ var hooks_useGetTopPoolsByApr = (useGetTopPoolsByApr);

// EXTERNAL MODULE: ./src/config/constants/pools.tsx
var pools = __webpack_require__(27717);
// EXTERNAL MODULE: ./src/hooks/useVaultApy.ts
var useVaultApy = __webpack_require__(3024);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Layouts/FlexGap.tsx
var FlexGap = __webpack_require__(46705);
;// CONCATENATED MODULE: ./src/views/Home/components/FarmsPoolsRow/TopFarmPool.tsx

function TopFarmPool_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    TopFarmPool_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopFarmPool_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        ";\n  opacity: ",
        ";\n  margin-top: ",
        ";\n  transition: opacity, margin-top, 0.4s ease-out;\n  flex-direction: column;\n\n  ",
        "\n"
    ]);
    TopFarmPool_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-79c0da63-0"
})(TopFarmPool_templateObject());
var AbsoluteWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-79c0da63-1"
})(TopFarmPool_templateObject1(), function(param) {
    var topOffset = param.topOffset;
    return topOffset;
}, function(param) {
    var visible = param.visible;
    return visible ? 1 : 0;
}, function(param) {
    var visible = param.visible;
    return visible ? 0 : "50%";
}, function(param) {
    var index = param.index, theme = param.theme;
    return index > 0 ? "\n         ".concat(theme.mediaQueries.sm, " {\n           height: 80px;\n           top: 0;\n           padding-left: 16px;\n           border-left: 1px ").concat(theme.colors.inputSecondary, " solid;\n         }\n       ") : "padding-right: 16px;";
});
var TopFarmPool = function(param) {
    var title = param.title, percentage = param.percentage, index = param.index, visible = param.visible;
    var t = (0,src/* useTranslation */.$G)().t;
    var topOffset = function() {
        if (index >= 0 && index < 2) {
            return "0px";
        }
        if (index >= 2 && index < 3) {
            return "80px";
        }
        return "160px";
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        index: index,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AbsoluteWrapper, {
            index: index,
            visible: visible,
            topOffset: topOffset(),
            children: [
                title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    bold: true,
                    mb: "8px",
                    fontSize: "12px",
                    color: "secondary",
                    children: title
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 80,
                    height: 12,
                    mb: "8px"
                }),
                percentage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexGap/* default */.Z, {
                    gap: "4px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        lineHeight: "1.1",
                        fontSize: "16px",
                        bold: true,
                        unit: "%",
                        value: percentage
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 60,
                    height: 16
                }),
                percentage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    fontSize: "16px",
                    color: "textSubtle",
                    children: t("APR")
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 30,
                    height: 16,
                    mt: "4px"
                })
            ]
        })
    });
};
/* harmony default export */ var FarmsPoolsRow_TopFarmPool = (TopFarmPool);

;// CONCATENATED MODULE: ./src/views/Home/components/FarmsPoolsRow/RowHeading.tsx






var RowHeading = function(_param) {
    var text = _param.text, props = (0,_object_without_properties/* default */.Z)(_param, [
        "text"
    ]);
    var theme = (0,useTheme/* default */.ZP)().theme;
    var split = text.split(" ");
    var firstWord = split[0];
    var remainingWords = split.slice(1).join(" ");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        children: [
            firstWord,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                style: {
                    color: theme.colors.secondary
                },
                children: [
                    " ",
                    remainingWords
                ]
            })
        ]
    }));
};
/* harmony default export */ var FarmsPoolsRow_RowHeading = (RowHeading);

;// CONCATENATED MODULE: ./src/views/Home/components/FarmsPoolsRow/index.tsx


function FarmsPoolsRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(2, auto);\n\n  ",
        " {\n    grid-gap: 16px;\n    grid-template-columns: repeat(5, auto);\n  }\n\n  ",
        " {\n    grid-gap: 32px;\n  }\n"
    ]);
    FarmsPoolsRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6dd2829b-0"
})(FarmsPoolsRow_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var FarmsPoolsRow = function() {
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(true), 2), showFarms = _useState[0], setShowFarms = _useState[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var _useIntersectionObserver = (0,hooks_src/* useIntersectionObserver */.S1)(), observerRef = _useIntersectionObserver.observerRef, isIntersecting = _useIntersectionObserver.isIntersecting;
    var _useGetTopFarmsByApr = hooks_useGetTopFarmsByApr(isIntersecting), topFarms = _useGetTopFarmsByApr.topFarms, fetched = _useGetTopFarmsByApr.fetched;
    var topPools = hooks_useGetTopPoolsByApr(fetched && isIntersecting).topPools;
    var lockedApy = (0,useVaultApy/* useVaultApy */.o)().lockedApy;
    var timer = (0,react.useRef)(null);
    var isLoaded = topFarms[0] && topPools[0];
    var startTimer = (0,react.useCallback)(function() {
        timer.current = setInterval(function() {
            setShowFarms(function(prev) {
                return !prev;
            });
        }, 6000);
    }, [
        timer
    ]);
    (0,react.useEffect)(function() {
        if (isLoaded) {
            startTimer();
        }
        return function() {
            clearInterval(timer.current);
        };
    }, [
        timer,
        isLoaded,
        startTimer
    ]);
    var getPoolText = function(pool) {
        if (pool.vaultKey) {
            return pools/* vaultPoolConfig */.Y4[pool.vaultKey].name;
        }
        return t("Stake %stakingSymbol% - Earn %earningSymbol%", {
            earningSymbol: pool.earningToken.symbol,
            stakingSymbol: pool.stakingToken.symbol
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: observerRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "column",
            mt: "24px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    mb: "24px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmsPoolsRow_RowHeading, {
                            text: showFarms ? t("Top Farms") : t("Top Syrup Pools")
                        }),
                        chainId === swap_sdk_dist/* ChainId.BSC */.a_.BSC && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            variant: "text",
                            height: "100%",
                            width: "auto",
                            onClick: function() {
                                setShowFarms(function(prev) {
                                    return !prev;
                                });
                                clearInterval(timer.current);
                                startTimer();
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapVert/* default */.Z, {
                                height: "24px",
                                width: "24px",
                                color: "textSubtle"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.ZP, {
                    height: [
                        "240px",
                        null,
                        "80px"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                            children: topFarms.map(function(topFarm, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(FarmsPoolsRow_TopFarmPool, {
                                    title: topFarm === null || topFarm === void 0 ? void 0 : topFarm.lpSymbol,
                                    percentage: (topFarm === null || topFarm === void 0 ? void 0 : topFarm.apr) + (topFarm === null || topFarm === void 0 ? void 0 : topFarm.lpRewardsApr),
                                    index: index,
                                    visible: showFarms
                                }, index);
                            })
                        }),
                        chainId === swap_sdk_dist/* ChainId.BSC */.a_.BSC && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid, {
                            children: topPools.map(function(topPool, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(FarmsPoolsRow_TopFarmPool, {
                                    title: topPool && getPoolText(topPool),
                                    percentage: (topPool === null || topPool === void 0 ? void 0 : topPool.sousId) === 0 ? +lockedApy : topPool === null || topPool === void 0 ? void 0 : topPool.apr,
                                    index: index,
                                    visible: !showFarms
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_FarmsPoolsRow = (FarmsPoolsRow);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Svg.tsx
var Svg_Svg = __webpack_require__(6816);
;// CONCATENATED MODULE: ./src/views/Home/components/SunburstSvg.tsx




var SunburstSvg = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 1956 1956"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_f)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M978 20L987.526 796.229L1078.14 25.248L1006.47 798.221L1177.18 40.9346L1025.11 802.182L1274.04 66.8879L1043.23 808.07L1367.65 102.823L1060.64 815.819L1457 148.348L1077.14 825.345L1541.1 202.962L1092.55 836.544L1619.03 266.067L1106.71 849.292L1689.93 336.973L1119.46 863.451L1753.04 414.902L1130.65 878.865L1807.65 499L1140.18 895.365L1853.18 588.346L1147.93 912.77L1889.11 681.962L1153.82 930.89L1915.07 778.821L1157.78 949.526L1930.75 877.862L1159.77 968.474L1936 978L1159.77 987.526L1930.75 1078.14L1157.78 1006.47L1915.07 1177.18L1153.82 1025.11L1889.11 1274.04L1147.93 1043.23L1853.18 1367.65L1140.18 1060.64L1807.65 1457L1130.65 1077.14L1753.04 1541.1L1119.46 1092.55L1689.93 1619.03L1106.71 1106.71L1619.03 1689.93L1092.55 1119.46L1541.1 1753.04L1077.14 1130.65L1457 1807.65L1060.64 1140.18L1367.65 1853.18L1043.23 1147.93L1274.04 1889.11L1025.11 1153.82L1177.18 1915.07L1006.47 1157.78L1078.14 1930.75L987.526 1159.77L978 1936L968.474 1159.77L877.862 1930.75L949.526 1157.78L778.821 1915.07L930.89 1153.82L681.962 1889.11L912.77 1147.93L588.346 1853.18L895.365 1140.18L499 1807.65L878.865 1130.65L414.902 1753.04L863.451 1119.46L336.973 1689.93L849.292 1106.71L266.067 1619.03L836.544 1092.55L202.962 1541.1L825.345 1077.14L148.348 1457L815.819 1060.64L102.823 1367.65L808.07 1043.23L66.8879 1274.04L802.182 1025.11L40.9346 1177.18L798.221 1006.47L25.248 1078.14L796.229 987.526L20 978L796.229 968.474L25.248 877.862L798.221 949.526L40.9346 778.821L802.182 930.89L66.8879 681.962L808.07 912.77L102.823 588.346L815.819 895.365L148.348 499L825.345 878.865L202.962 414.902L836.544 863.451L266.067 336.973L849.292 849.292L336.973 266.067L863.451 836.544L414.902 202.962L878.865 825.345L499 148.348L895.365 815.819L588.346 102.823L912.77 808.07L681.962 66.8879L930.89 802.182L778.821 40.9346L949.526 798.221L877.862 25.248L968.474 796.229L978 20Z",
                    fill: "url(#paint0_radial)",
                    fillOpacity: "0.1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_f",
                        x: "0",
                        y: "0",
                        width: "1956",
                        height: "1956",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "10",
                                result: "effect1_foregroundBlur"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint0_radial",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(978 978) rotate(90) scale(958)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.114547",
                                stopColor: "white",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.374975",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_SunburstSvg = (SunburstSvg);

;// CONCATENATED MODULE: ./src/views/Home/components/Footer.tsx



function Footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n"
    ]);
    Footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Footer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 350%;\n  width: 350%;\n\n  ",
        " {\n    height: 400%;\n    width: 400%;\n  }\n"
    ]);
    Footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Footer_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: relative;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"
    ]);
    Footer_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Footer_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  visibility: hidden;\n\n  ",
        " {\n   \n  }\n"
    ]);
    Footer_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Footer_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n"
    ]);
    Footer_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Footer_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: 0;\n"
    ]);
    Footer_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var Footer_BgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a50b2f8e-0"
})(Footer_templateObject());
var StyledSunburst = (0,styled_components_browser_esm/* default */.ZP)(components_SunburstSvg).withConfig({
    componentId: "sc-a50b2f8e-1"
})(Footer_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var Footer_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a50b2f8e-2"
})(Footer_templateObject2());
var FloatingPancakesWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-a50b2f8e-3"
})(Footer_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var TopLeftImgWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a50b2f8e-4"
})(Footer_templateObject4());
var BottomRightImgWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-a50b2f8e-5"
})(Footer_templateObject5());
var topLeftImage = {
    path: "/images/home/flying-pancakes/",
    attributes: [
        {
            src: "1-bottom",
            alt: "Pancake flying on the bottom"
        },
        {
            src: "1-left",
            alt: "Pancake flying on the left"
        },
        {
            src: "1-top",
            alt: "Pancake flying on the top"
        }
    ]
};
var bottomRightImage = {
    path: "/images/home/flying-pancakes/",
    attributes: [
        {
            src: "2-bottom",
            alt: "Pancake flying on the bottom"
        },
        {
            src: "2-top",
            alt: "Pancake flying on the top"
        },
        {
            src: "2-right",
            alt: "Pancake flying on the right"
        }
    ]
};
var Footer = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var _useAccount = (0,wagmi_dist/* useAccount */.mA)(), account = _useAccount.address;
    var _useMatchBreakpoints = (0,useMatchBreakpoints/* default */.Z)(), isTablet = _useMatchBreakpoints.isTablet, isDesktop = _useMatchBreakpoints.isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_BgWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSunburst, {})
                })
            }),
            (isTablet || isDesktop) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(FloatingPancakesWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TopLeftImgWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, topLeftImage), {
                            maxHeight: "256px"
                        }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomRightImgWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CompositeImage, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, bottomRightImage), {
                            maxHeight: "256px"
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        mb: "24px",
                        scale: "xl",
                        color: "white",
                        children: t("Start in seconds.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "center",
                        color: "white",
                        children: t("Connect your crypto wallet to start using the app in seconds.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        mb: "24px",
                        bold: true,
                        color: "white",
                        children: t("No registration needed.")
                    }),
                    !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
                        mt: "24px"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Footer = (Footer);

// EXTERNAL MODULE: ./src/config/abi/cake.json
var cake = __webpack_require__(93361);
// EXTERNAL MODULE: ../../packages/tokens/src/56.ts
var _56 = __webpack_require__(47609);
// EXTERNAL MODULE: ./src/utils/multicall.ts
var multicall = __webpack_require__(60242);
// EXTERNAL MODULE: ./src/utils/addressHelpers.ts
var addressHelpers = __webpack_require__(81254);
// EXTERNAL MODULE: ./src/config/abi/cakeVaultV2.json
var cakeVaultV2 = __webpack_require__(93293);
// EXTERNAL MODULE: ../../node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(10528);
;// CONCATENATED MODULE: ./src/views/Home/components/CakeDataRow.tsx




function CakeDataRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  ",
        "\n\n  ",
        "\n"
    ]);
    CakeDataRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CakeDataRow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: 16px 8px;\n  margin-top: 24px;\n  grid-template-columns: repeat(2, auto);\n  grid-template-areas:\n    'a d'\n    'b e'\n    'c f';\n\n  ",
        " {\n    grid-gap: 16px;\n  }\n\n  ",
        " {\n    grid-template-areas:\n      'a b c'\n      'd e f';\n    grid-gap: 32px;\n    grid-template-columns: repeat(3, auto);\n  }\n"
    ]);
    CakeDataRow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var StyledColumn = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-d932e38f-0"
})(CakeDataRow_templateObject(), function(param) {
    var noMobileBorder = param.noMobileBorder, theme = param.theme;
    return noMobileBorder ? "".concat(theme.mediaQueries.md, " {\n           padding: 0 16px;\n           border-left: 1px ").concat(theme.colors.inputSecondary, " solid;\n         }\n       ") : "border-left: 1px ".concat(theme.colors.inputSecondary, " solid;\n         padding: 0 8px;\n         ").concat(theme.mediaQueries.sm, " {\n           padding: 0 16px;\n         }\n       ");
}, function(param) {
    var noDesktopBorder = param.noDesktopBorder, theme = param.theme;
    return noDesktopBorder && "".concat(theme.mediaQueries.md, " {\n           padding: 0;\n           border-left: none;\n         }\n       ");
});
var CakeDataRow_Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d932e38f-1"
})(CakeDataRow_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var emissionsPerBlock = 11.16;
/**
 * User (Planet Finance) built a contract on top of our original manual CAKE pool,
 * but the contract was written in such a way that when we performed the migration from Masterchef v1 to v2, the tokens were stuck.
 * These stuck tokens are forever gone (see their medium post) and can be considered out of circulation."
 * https://planetfinanceio.medium.com/pancakeswap-works-with-planet-to-help-cake-holders-f0d253b435af
 * https://twitter.com/PancakeSwap/status/1523913527626702849
 * https://bscscan.com/tx/0xd5ffea4d9925d2f79249a4ce05efd4459ed179152ea5072a2df73cd4b9e88ba7
 */ var planetFinanceBurnedTokensWei = bignumber/* BigNumber.from */.O$.from("637407922445268000000000");
var cakeVaultAddress = (0,addressHelpers/* getCakeVaultAddress */.O9)();
var CakeDataRow = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var _useIntersectionObserver = (0,hooks_src/* useIntersectionObserver */.S1)(), observerRef = _useIntersectionObserver.observerRef, isIntersecting = _useIntersectionObserver.isIntersecting;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(false), 2), loadData = _useState[0], setLoadData = _useState[1];
    var _useSWR = (0,dist/* default */.ZP)(loadData ? [
        "cakeDataRow"
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var totalSupplyCall, burnedTokenCall, cakeVaultCall, _ref, _ref_, totalSupply, _ref_1, burned, _ref_2, totalLockedAmount, totalBurned, circulating;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    totalSupplyCall = {
                        abi: cake,
                        address: _56/* bscTokens.cake.address */.d.cake.address,
                        name: "totalSupply"
                    };
                    burnedTokenCall = {
                        abi: cake,
                        address: _56/* bscTokens.cake.address */.d.cake.address,
                        name: "balanceOf",
                        params: [
                            "0x000000000000000000000000000000000000dEaD"
                        ]
                    };
                    cakeVaultCall = {
                        abi: cakeVaultV2,
                        address: cakeVaultAddress,
                        name: "totalLockedAmount"
                    };
                    return [
                        4,
                        (0,multicall/* multicallv3 */.OF)({
                            calls: [
                                totalSupplyCall,
                                burnedTokenCall,
                                cakeVaultCall
                            ],
                            allowFailure: true
                        })
                    ];
                case 1:
                    _ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                        _state.sent(),
                        3
                    ]), _ref_ = (0,_sliced_to_array/* default */.Z)(_ref[0], 1), totalSupply = _ref_[0], _ref_1 = (0,_sliced_to_array/* default */.Z)(_ref[1], 1), burned = _ref_1[0], _ref_2 = (0,_sliced_to_array/* default */.Z)(_ref[2], 1), totalLockedAmount = _ref_2[0];
                    totalBurned = planetFinanceBurnedTokensWei.add(burned);
                    circulating = totalSupply.sub(totalBurned.add(totalLockedAmount));
                    return [
                        2,
                        {
                            cakeSupply: totalSupply && burned ? +(0,formatBalance/* formatBigNumber */.dp)(totalSupply.sub(totalBurned)) : 0,
                            burnedBalance: burned ? +(0,formatBalance/* formatBigNumber */.dp)(totalBurned) : 0,
                            circulatingSupply: circulating ? +(0,formatBalance/* formatBigNumber */.dp)(circulating) : 0
                        }
                    ];
            }
        });
    }), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    }), tmp = _useSWR.data, _ref = tmp === void 0 ? {
        cakeSupply: 0,
        burnedBalance: 0,
        circulatingSupply: 0
    } : tmp, cakeSupply = _ref.cakeSupply, burnedBalance = _ref.burnedBalance, circulatingSupply = _ref.circulatingSupply;
    var cakePriceBusd = (0,hooks/* usePriceCakeBusd */.Iu)();
    var mcap = cakePriceBusd.times(circulatingSupply);
    var mcapString = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(mcap.toNumber());
    (0,react.useEffect)(function() {
        if (isIntersecting) {
            setLoadData(true);
        }
    }, [
        isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CakeDataRow_Grid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                style: {
                    gridArea: "a"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Circulating Supply")
                    }),
                    circulatingSupply ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: circulatingSupply
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 126,
                        my: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                noMobileBorder: true,
                style: {
                    gridArea: "b"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Total supply")
                    }),
                    cakeSupply ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: cakeSupply
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: observerRef
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                height: 24,
                                width: 126,
                                my: "4px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                noMobileBorder: true,
                style: {
                    gridArea: "c"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Max Supply")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: 750000000
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                noDesktopBorder: true,
                style: {
                    gridArea: "d"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Market cap")
                    }),
                    (mcap === null || mcap === void 0 ? void 0 : mcap.gt(0)) && mcapString ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "lg",
                        children: t("$%marketCap%", {
                            marketCap: mcapString
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 126,
                        my: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                style: {
                    gridArea: "e"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Burned to date")
                    }),
                    burnedBalance ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                        decimals: 0,
                        lineHeight: "1.1",
                        fontSize: "24px",
                        bold: true,
                        value: burnedBalance
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                        height: 24,
                        width: 126,
                        my: "4px"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledColumn, {
                style: {
                    gridArea: "f"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "textSubtle",
                        children: t("Current emissions")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        scale: "lg",
                        children: t("%cakeEmissions%/block", {
                            cakeEmissions: emissionsPerBlock
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CakeDataRow = (CakeDataRow);

;// CONCATENATED MODULE: ./src/views/Home/components/WedgeSvgs.tsx



function WedgeSvgs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  right: 0px;\n  top: 0px;\n"
    ]);
    WedgeSvgs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WedgeSvgs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  width: 100%;\n  ",
        ";\n\n  svg {\n    fill: ",
        ";\n    width: ",
        ";\n    height: 100%;\n    max-height: 48px;\n  }\n"
    ]);
    WedgeSvgs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var OuterWedgeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-cbf3a528-0"
})(WedgeSvgs_templateObject());
var InnerWedgeWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({
    className: "inner-wedge"
}).withConfig({
    componentId: "sc-cbf3a528-1"
})(WedgeSvgs_templateObject1(), function(param) {
    var top = param.top;
    return top ? "top: 0px" : "bottom: 0px";
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var width = param.width;
    return width || "100%";
});
var WedgeTopLeft = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1660 48C1139.02 46.1887 336.256 15.2453 0 0H1660V48Z"
        })
    }));
};
var WedgeTopRight = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg_Svg/* default */.Z, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M-346 48C174.985 46.1887 977.744 15.2453 1314 0H-346V48Z"
        })
    }));
};
var WedgeBottomRight = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M0 0C520.985 1.81132 1323.74 32.7547 1660 48H0V0Z"
        })
    }));
};
var WedgeBottomLeft = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 1660 48"
    }, props), {
        preserveAspectRatio: "none",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1660 0C1139.02 1.81132 336.256 32.7547 0 48H1660V0Z"
        })
    }));
};

// EXTERNAL MODULE: ../../packages/uikit/src/contexts/ToastsContext/useToast.ts
var useToast = __webpack_require__(25130);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(59696);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(40330);
// EXTERNAL MODULE: ../../node_modules/bignumber.js/bignumber.js
var bignumber_js_bignumber = __webpack_require__(6391);
var bignumber_default = /*#__PURE__*/__webpack_require__.n(bignumber_js_bignumber);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 1 modules
var Toast = __webpack_require__(86054);
// EXTERNAL MODULE: ./src/hooks/useCatchTxError.tsx
var useCatchTxError = __webpack_require__(90395);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(38497);
// EXTERNAL MODULE: ./src/utils/calls/index.ts + 2 modules
var calls = __webpack_require__(62217);
// EXTERNAL MODULE: ./src/config/index.ts
var config = __webpack_require__(16816);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(90327);
// EXTERNAL MODULE: ./src/config/abi/masterchef.json
var masterchef = __webpack_require__(84951);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 2 modules
var useContract = __webpack_require__(56521);
// EXTERNAL MODULE: ./src/utils/verifyBscNetwork.ts
var verifyBscNetwork = __webpack_require__(15241);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useBCakeProxyContractAddress.ts
var useBCakeProxyContractAddress = __webpack_require__(70688);
// EXTERNAL MODULE: ./src/views/Farms/components/YieldBooster/helpers/splitProxyFarms.ts
var splitProxyFarms = __webpack_require__(56835);
;// CONCATENATED MODULE: ./src/views/Home/hooks/useFarmsWithBalance.tsx


















var useFarmsWithBalance = function() {
    var _useActiveWeb3React = (0,useActiveWeb3React/* default */.Z)(), account = _useActiveWeb3React.account, chainId = _useActiveWeb3React.chainId;
    var _useFarmsLength = (0,hooks/* useFarmsLength */.f5)(), poolLength = _useFarmsLength.data;
    var proxyAddress = (0,useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account, chainId).proxyAddress;
    var bCakeProxy = (0,useContract/* useBCakeProxyContract */.DE)(proxyAddress);
    var masterChefContract = (0,useContract/* useMasterchef */.y8)();
    var getFarmsWithBalances = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(farms, accountToCheck, contract) {
            var calls, rawResults, results, farmsWithBalances, totalEarned;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        calls = farms.map(function(farm) {
                            return {
                                address: masterChefContract.address,
                                name: "pendingCake",
                                params: [
                                    farm.pid,
                                    accountToCheck
                                ]
                            };
                        });
                        return [
                            4,
                            (0,multicall/* default */.ZP)(masterchef, calls)
                        ];
                    case 1:
                        rawResults = _state.sent();
                        results = farms.map(function(farm, index) {
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, farm), {
                                balance: new (bignumber_default())(rawResults[index])
                            });
                        });
                        farmsWithBalances = results.filter(function(balanceType) {
                            return balanceType.balance.gt(0);
                        }).map(function(farm) {
                            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, farm), {
                                contract: contract
                            });
                        });
                        totalEarned = farmsWithBalances.reduce(function(accum, earning) {
                            var earningNumber = new (bignumber_default())(earning.balance);
                            if (earningNumber.eq(0)) {
                                return accum;
                            }
                            return accum + earningNumber.div(config/* DEFAULT_TOKEN_DECIMAL */.o3).toNumber();
                        }, 0);
                        return [
                            2,
                            {
                                farmsWithBalances: farmsWithBalances,
                                totalEarned: totalEarned
                            }
                        ];
                }
            });
        });
        return function getFarmsWithBalances(farms, accountToCheck, contract) {
            return _ref.apply(this, arguments);
        };
    }();
    var _useSWR = (0,dist/* default */.ZP)(account && poolLength && chainId ? [
        account,
        "farmsWithBalance",
        chainId,
        poolLength
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var farmsConfig, farmsCanFetch, normalBalances, farmsWithProxy, proxyBalances;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,farms_constants.getFarmConfig)(chainId)
                    ];
                case 1:
                    farmsConfig = _state.sent();
                    farmsCanFetch = farmsConfig.filter(function(f) {
                        return poolLength > f.pid;
                    });
                    return [
                        4,
                        getFarmsWithBalances(farmsCanFetch, account, masterChefContract)
                    ];
                case 2:
                    normalBalances = _state.sent();
                    if (!(proxyAddress && (farmsCanFetch === null || farmsCanFetch === void 0 ? void 0 : farmsCanFetch.length) && (0,verifyBscNetwork/* verifyBscNetwork */.H)(chainId))) return [
                        3,
                        4
                    ];
                    farmsWithProxy = (0,splitProxyFarms/* default */.Z)(farmsCanFetch).farmsWithProxy;
                    return [
                        4,
                        getFarmsWithBalances(farmsWithProxy, proxyAddress, bCakeProxy)
                    ];
                case 3:
                    proxyBalances = _state.sent();
                    return [
                        2,
                        {
                            farmsWithStakedBalance: (0,_to_consumable_array/* default */.Z)(normalBalances.farmsWithBalances).concat((0,_to_consumable_array/* default */.Z)(proxyBalances.farmsWithBalances)),
                            earningsSum: normalBalances.totalEarned + proxyBalances.totalEarned
                        }
                    ];
                case 4:
                    return [
                        2,
                        {
                            farmsWithStakedBalance: normalBalances.farmsWithBalances,
                            earningsSum: normalBalances.totalEarned
                        }
                    ];
            }
        });
    }), {
        refreshInterval: constants/* FAST_INTERVAL */.sR
    }), tmp = _useSWR.data, _ref = tmp === void 0 ? {
        farmsWithStakedBalance: [],
        earningsSum: null
    } : tmp, farmsWithStakedBalance = _ref.farmsWithStakedBalance, earningsSum = _ref.earningsSum;
    return {
        farmsWithStakedBalance: farmsWithStakedBalance,
        earningsSum: earningsSum
    };
};
/* harmony default export */ var hooks_useFarmsWithBalance = (useFarmsWithBalance);

;// CONCATENATED MODULE: ./src/views/Home/components/UserBanner/EarningsText.tsx
var getEarningsText = function(numFarmsToCollect, hasCakePoolToCollect, earningsBusd, t) {
    var data = {
        earningsBusd: earningsBusd.toString(),
        count: numFarmsToCollect
    };
    var earningsText = t("%earningsBusd% to collect", data);
    if (numFarmsToCollect > 0 && hasCakePoolToCollect) {
        if (numFarmsToCollect > 1) {
            earningsText = t("%earningsBusd% to collect from %count% farms and CAKE pool", data);
        } else {
            earningsText = t("%earningsBusd% to collect from %count% farm and CAKE pool", data);
        }
    } else if (numFarmsToCollect > 0) {
        if (numFarmsToCollect > 1) {
            earningsText = t("%earningsBusd% to collect from %count% farms", data);
        } else {
            earningsText = t("%earningsBusd% to collect from %count% farm", data);
        }
    } else if (hasCakePoolToCollect) {
        earningsText = t("%earningsBusd% to collect from CAKE pool", data);
    }
    return earningsText;
};

;// CONCATENATED MODULE: ./src/views/Home/components/UserBanner/HarvestCard.tsx




function HarvestCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: fit-content;\n"
    ]);
    HarvestCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}















var HarvestCard_StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Card/* default */.Z).withConfig({
    componentId: "sc-9e16dd6d-0"
})(HarvestCard_templateObject());
var masterChefAddress = (0,addressHelpers/* getMasterChefAddress */.Oc)();
var HarvestCard = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var toastSuccess = (0,useToast/* useToast */.p)().toastSuccess;
    var _useCatchTxError = (0,useCatchTxError/* default */.Z)(), fetchWithCatchTxError = _useCatchTxError.fetchWithCatchTxError, pendingTx = _useCatchTxError.loading;
    var _useFarmsWithBalance = hooks_useFarmsWithBalance(), farmsWithStakedBalance = _useFarmsWithBalance.farmsWithStakedBalance, farmEarningsSum = _useFarmsWithBalance.earningsSum;
    var cakePriceBusd = (0,hooks/* usePriceCakeBusd */.Iu)();
    var gasPrice = (0,user_hooks/* useGasPrice */.Fh)();
    var earningsBusd = new (bignumber_default())(farmEarningsSum).multipliedBy(cakePriceBusd);
    var numTotalToCollect = farmsWithStakedBalance.length;
    var numFarmsToCollect = farmsWithStakedBalance.filter(function(value) {
        return value.pid !== 0;
    }).length;
    var hasCakePoolToCollect = numTotalToCollect - numFarmsToCollect > 0;
    var earningsText = getEarningsText(numFarmsToCollect, hasCakePoolToCollect, earningsBusd, t);
    var _earningsText_split = (0,_sliced_to_array/* default */.Z)(earningsText.split(earningsBusd.toString()), 2), preText = _earningsText_split[0], toCollectText = _earningsText_split[1];
    var harvestAllFarms = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var i, farmWithBalance, receipt;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(i < farmsWithStakedBalance.length)) return [
                        3,
                        4
                    ];
                    farmWithBalance = farmsWithStakedBalance[i];
                    return [
                        4,
                        fetchWithCatchTxError(function() {
                            return (0,calls/* harvestFarm */.sA)(farmWithBalance.contract, farmWithBalance.pid, gasPrice, farmWithBalance.contract.address !== masterChefAddress ? config/* BOOSTED_FARM_GAS_LIMIT */.ZM : undefined);
                        })
                    ];
                case 2:
                    receipt = _state.sent();
                    if (receipt === null || receipt === void 0 ? void 0 : receipt.status) {
                        toastSuccess("".concat(t("Harvested"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.Y, {
                            txHash: receipt.transactionHash,
                            children: t("Your %symbol% earnings have been sent to your wallet!", {
                                symbol: "CAKE"
                            })
                        }));
                    }
                    _state.label = 3;
                case 3:
                    i++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        farmsWithStakedBalance,
        toastSuccess,
        t,
        fetchWithCatchTxError,
        gasPrice
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HarvestCard_StyledCard, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardBody/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: [
                    "column",
                    null,
                    null,
                    "row"
                ],
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        alignItems: [
                            "center",
                            null,
                            null,
                            "flex-start"
                        ],
                        children: [
                            preText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mb: "4px",
                                color: "textSubtle",
                                children: preText
                            }),
                            !earningsBusd.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                                decimals: earningsBusd.gt(0) ? 2 : 0,
                                fontSize: "24px",
                                bold: true,
                                prefix: earningsBusd.gt(0) ? "~$" : "$",
                                lineHeight: "1.1",
                                value: earningsBusd.toNumber()
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: 96,
                                height: 24,
                                my: "2px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mb: [
                                    "16px",
                                    null,
                                    null,
                                    "0"
                                ],
                                color: "textSubtle",
                                children: toCollectText
                            })
                        ]
                    }),
                    numTotalToCollect <= 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                        to: "farms",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            width: [
                                "100%",
                                null,
                                null,
                                "auto"
                            ],
                            variant: "secondary",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: "primary",
                                    bold: true,
                                    children: t("Start earning")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                    ml: "4px",
                                    color: "primary"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        width: [
                            "100%",
                            null,
                            null,
                            "auto"
                        ],
                        id: "harvest-all",
                        isLoading: pendingTx,
                        endIcon: pendingTx ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                            spin: true,
                            color: "currentColor"
                        }) : null,
                        disabled: pendingTx,
                        onClick: harvestAllFarms,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "invertedContrast",
                            bold: true,
                            children: pendingTx ? t("Harvesting") : t("Harvest all")
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var UserBanner_HarvestCard = (HarvestCard);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/NoProfileAvatar.tsx
var NoProfileAvatar = __webpack_require__(16775);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/VisibilityOff.tsx
var VisibilityOff = __webpack_require__(1635);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/VisibilityOn.tsx
var VisibilityOn = __webpack_require__(60454);
// EXTERNAL MODULE: ./src/state/profile/hooks.ts + 2 modules
var profile_hooks = __webpack_require__(61491);
// EXTERNAL MODULE: ./src/components/ProfileAvatarWithTeam.tsx
var ProfileAvatarWithTeam = __webpack_require__(32331);
// EXTERNAL MODULE: ../../packages/utils/truncateHash.ts
var truncateHash = __webpack_require__(71967);
// EXTERNAL MODULE: ./src/hooks/useUsernameWithVisibility.ts
var useUsernameWithVisibility = __webpack_require__(85264);
;// CONCATENATED MODULE: ./src/views/Home/components/UserBanner/UserDetail.tsx

function UserDetail_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: none;\n  ",
        " {\n    display: flex;\n  }\n"
    ]);
    UserDetail_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function UserDetail_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    UserDetail_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function UserDetail_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 92px;\n  width: 92px;\n  background-color: ",
        ";\n  border: 3px solid ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    UserDetail_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function UserDetail_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n  width: 100%;\n"
    ]);
    UserDetail_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var Desktop = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9b0a7adf-0"
})(UserDetail_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var Mobile = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9b0a7adf-1"
})(UserDetail_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var Sticker = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9b0a7adf-2"
})(UserDetail_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
}, function(param) {
    var theme = param.theme;
    return theme.radii.circle;
}, function(param) {
    var theme = param.theme;
    return theme.card.boxShadow;
});
var StyledNoProfileAvatarIcon = (0,styled_components_browser_esm/* default */.ZP)(NoProfileAvatar/* default */.Z).withConfig({
    componentId: "sc-9b0a7adf-3"
})(UserDetail_templateObject3());
var UserDetail = function() {
    var _useProfile = (0,profile_hooks/* useProfile */.Un)(), profile = _useProfile.profile, isLoading = _useProfile.isLoading;
    var t = (0,src/* useTranslation */.$G)().t;
    var _useAccount = (0,wagmi_dist/* useAccount */.mA)(), account = _useAccount.address;
    var _useMatchBreakpoints = (0,useMatchBreakpoints/* default */.Z)(), isMobile = _useMatchBreakpoints.isMobile, isTablet = _useMatchBreakpoints.isTablet, isDesktop = _useMatchBreakpoints.isDesktop;
    var _useGetUsernameWithVisibility = (0,useUsernameWithVisibility/* default */.Z)(profile), usernameWithVisibility = _useGetUsernameWithVisibility.usernameWithVisibility, userUsernameVisibility = _useGetUsernameWithVisibility.userUsernameVisibility, setUserUsernameVisibility = _useGetUsernameWithVisibility.setUserUsernameVisibility;
    var toggleUsernameVisibility = function() {
        setUserUsernameVisibility(!userUsernameVisibility);
    };
    var Icon = userUsernameVisibility ? VisibilityOff/* default */.Z : VisibilityOn/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (isTablet || isDesktop) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Desktop, {
                style: {
                    display: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.ZP, {
                        mr: "24px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Sticker, {
                            children: profile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileAvatarWithTeam/* default */.Z, {
                                profile: profile
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNoProfileAvatarIcon, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flexDirection: "column",
                        children: [
                            profile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                                scale: "xl",
                                children: [
                                    t("Hi, %userName%!", {
                                        userName: usernameWithVisibility
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                        ml: "4px",
                                        onClick: toggleUsernameVisibility,
                                        cursor: "pointer"
                                    })
                                ]
                            }) : isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: 200,
                                height: 40,
                                my: "4px"
                            }) : null,
                            isLoading || !account ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                width: 160,
                                height: 16,
                                my: "4px"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "16px",
                                children: [
                                    " ",
                                    t("Connected with %address%", {
                                        address: (0,truncateHash/* default */.Z)(account)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Mobile, {
                children: profile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading/* default */.Z, {
                    mb: "18px",
                    textAlign: "center",
                    children: [
                        t("Hi, %userName%!", {
                            userName: usernameWithVisibility
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                            ml: "4px",
                            onClick: toggleUsernameVisibility,
                            cursor: "pointer"
                        })
                    ]
                }) : isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    width: 120,
                    height: 20,
                    mt: "2px",
                    mb: "18px"
                }) : null
            })
        ]
    });
};
/* harmony default export */ var UserBanner_UserDetail = (UserDetail);

;// CONCATENATED MODULE: ./src/views/Home/components/UserBanner/index.tsx

function UserBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px ",
        " solid;\n  border-left: 1px ",
        " solid;\n  border-right: 1px ",
        " solid;\n  border-radius: ",
        ";\n  background: ",
        ";\n"
    ]);
    UserBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var UserBanner_StyledCard = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.ZP).withConfig({
    componentId: "sc-27518e24-0"
})(UserBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
}, function(param) {
    var theme = param.theme;
    return "0 0 ".concat(theme.radii.card, " ").concat(theme.radii.card);
}, function(param) {
    var theme = param.theme;
    return theme.isDark ? "linear-gradient(360deg, rgba(49, 61, 92, 0.9) 0%, rgba(61, 42, 84, 0.9) 100%)" : "linear-gradient(180deg, rgba(202, 194, 236, 0.9) 0%,  rgba(204, 220, 239, 0.9) 51.04%, rgba(206, 236, 243, 0.9) 100%)";
});
var UserBanner = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBanner_StyledCard, {
        p: [
            "16px",
            null,
            null,
            "24px"
        ],
        style: {
            display: "none"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            alignItems: "center",
            justifyContent: "center",
            flexDirection: [
                "column",
                null,
                null,
                "row"
            ],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    flex: "1",
                    mr: [
                        null,
                        null,
                        null,
                        "32px"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBanner_UserDetail, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    flex: "1",
                    width: [
                        "100%",
                        null,
                        "auto"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBanner_HarvestCard, {})
                })
            ]
        })
    });
};
/* harmony default export */ var components_UserBanner = (UserBanner);

// EXTERNAL MODULE: ../../packages/uikit/src/util/animationToolkit.ts
var animationToolkit = __webpack_require__(26074);
// EXTERNAL MODULE: ../../packages/uikit/src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(36932);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(37069);
// EXTERNAL MODULE: ../../node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(55490);
// EXTERNAL MODULE: ../../node_modules/swiper/modules/effect-fade/effect-fade.min.css
var effect_fade_min = __webpack_require__(33747);
// EXTERNAL MODULE: ../../node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(97038);
// EXTERNAL MODULE: ../../node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(57506);
// EXTERNAL MODULE: ../../node_modules/lodash/shuffle.js
var shuffle = __webpack_require__(46152);
var shuffle_default = /*#__PURE__*/__webpack_require__.n(shuffle);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/lottery.png
/* harmony default export */ var lottery = ({"src":"/_next/static/media/lottery.77a09738.png","height":456,"width":2291,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAIVBMVEVMaXGJzdzEqZrcy0nGf4bhsGvNrm/Xn53Lm9ln2dnUmZ9TIYycAAAAC3RSTlMAM85oJBqVc0obc4UzhHoAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAaSURBVHicY2Bg4GRkZediZmBg4GBkYWJiAwACHQA7F8m+ugAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/IFO.png
/* harmony default export */ var IFO = ({"src":"/_next/static/media/IFO.7b008469.png","height":422,"width":582,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAb1BMVEUySl48q/N8r9PpjHSAZFvRwsXezMvC//+cNhJuxeAsqcXLm5Mrn+4SkOpgw/Cxl4Z7VkW3IgDMzcHVzc931v+LUVaic2+tb1WOgHaQh4/asX5vutbr7O/z8fbQu7fGqqN3jZRwl7CPYE6709n///9KAmQTAAAAIHRSTlMChodr/Hn6FxCHboqNv2fB+1nu2ZZqd7v512n8+Zyr8+Fk6nkAAAAJcEhZcwAACxMAAAsTAQCanBgAAAA6SURBVHicBcGFAYAwEACxK9S+SHF32H9GEsCVKi8C4ES6JAOPXxqTYmw7xneu2b9tuta757Cn1tUz/DcxAsKIEvzgAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/IFOMobile.png
/* harmony default export */ var IFOMobile = ({"src":"/_next/static/media/IFOMobile.a93e96d8.png","height":346,"width":338,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAhFBMVEVMaXGnVDIqqOi+5fT08/iISD7cw6x4cLCulZvv6u3i2dzs7PJz2fXLsaiOQx6T3ejNt7Cek7eYcmp9YVqmoJubiaSab4htbmpok57GqpqZfJWdcmRSu+xKlOa+yMyTTUgujO+yy9Hgk4iqpoW/incgnPVtdIMmhseXy+ddnrSiYlmPX1C0ExctAAAAK3RSTlMAQr2H/RXREEH8WGOCdiIt9jLj+fdXtf736YPSxR/X6THxh0VttvVX+/r6rFpRsAAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAEZJREFUeJwVxsURwCAABMDDIe7untB/fxleuwAANS63MxjoSV3inbENSmtC5HTAM6bt12eGz3lRN++FMJFZbu2HSECkZVf9e9YEC+V/KkcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/competition.png
/* harmony default export */ var competition = ({"src":"/_next/static/media/competition.67316e07.png","height":426,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAHlBMVEVVQZWMboxyVarEo1ifeWJWNpasi7iEXspKKorbzFPZIyBXAAAACnRSTlMDv4Hgtji5jRjcSlADPgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAABpJREFUeJxjYGBgYGVn42RkYGBg4GBiZGYBAAGlAC+qNEJFAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/competitionMobile.png
/* harmony default export */ var competitionMobile = ({"src":"/_next/static/media/competitionMobile.48f2da21.png","height":364,"width":676,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAM1BMVEVMaXHhzYOWhXu5jE7/15zq1x+1nZrWuym2sJHhvYjBts5uUaayWC5sR2SqgaOSaXG0jbnZKJh9AAAAEHRSTlMA58/MDdT1vSp4s+CQnnj7cAo0GQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACFJREFUeJxjYAABVnZeEMXCycjMD2JwsHHxCYBleNiZuAEIRQCQXnLcZwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/mod-tc-desktop.png
/* harmony default export */ var mod_tc_desktop = ({"src":"/_next/static/media/mod-tc-desktop.e1700017.png","height":677,"width":1290,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAP1BMVEW6j7L/ZwCXZZWWVVJNTkKEbn6KeqoAP///hoa8mKWYc62eVVGAcIBcX1r///9AeG+UYlTPuMa1YjqTdVfbxOigxH61AAAAFXRSTlMNG36VmGkwAQIVn3SPyheufzaRu3t/k4s8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKUlEQVR4nAXBhQEAIAzAsKLbcPv/VhJExRAFQ2pw+5FTif2uAb7FmQ4fEMYBAiXfjBIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/mod-tc-mobile.png
/* harmony default export */ var mod_tc_mobile = ({"src":"/_next/static/media/mod-tc-mobile.92900d89.png","height":403,"width":412,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAb1BMVEWqeXm9bDPWgWaQXZbyyveXQjp1W0ymetecX5zGrMnEuNKhUFnbhmaParCga6B1OV95PD6vkr7Cs9X10/p5RmZ3Y3pVNy5+jX1EXlZfOS5TWklocXKyeVBjk4HJZjTmbSm0c1d2Vkr///+oXWOUUjwyNYo2AAAAIXRSTlMBezmfHSGjCChgg4lXifrIhsabcFDYeJ/265KOsUWmnv73oDlZAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVR4nB3FxRGAMAAAwQtEcXcL0H+NTNjPQmCc/Ce521CUuUaCNenTYTBxXr16O7FFPcyrF1D2k7/8Dmpc9CHUB1GVAxM4DnPNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/lotteryMobile.png
/* harmony default export */ var lotteryMobile = ({"src":"/_next/static/media/lotteryMobile.7ad41ede.png","height":278,"width":376,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAZlBMVEVMaXG4pKy/n6OvhZqeisLIt9zVk4WokrSfjbzb0rrQf2TJoZ3o5WnYvkjp0Fvg1k3avz7StEistLWjmtrQn4zakm7Mf5jEopHIu67XoaWdua7UwuDdpIviwGDAfne8pdbRtzTZyo++QnXCAAAAIHRSTlMAlLU9TTvPKxYcJsqUzY595rbDOPOSjmn5tOVU0PjkRiIjEF8AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA6SURBVHicBcGHEYAwDACxDzixTe8dDvZfEglwxasW4rkvftdYmtMV3o7xmbYv9A0qw7FKVhLNFMmLH0CAAlcDCHXCAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/mod-white-logo.png
/* harmony default export */ var mod_white_logo = ({"src":"/_next/static/media/mod-white-logo.02856f5f.png","height":134,"width":489,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEX///////////////////////////9nSIHRAAAAB3RSTlModWIwFUVQHYhWcgAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxjYGFmYGBmZmBhYGNkYmJkZGQFAAFUACWNHhzuAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/perpetual.png
/* harmony default export */ var perpetual = ({"src":"/_next/static/media/perpetual.fd0aa080.png","height":464,"width":784,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAUVBMVEWqgevsRZc1z6Yi/+fjR5XPnkwy2q/xTaXqT4T0PpbVrF/lmEtc4rAtv6O7wXMm0q/Zwm51xn7jrInAt5bvSJzqlU8Z46PPz6rn7vHNxI3rvWXl5yU8AAAAGXRSTlMDpWUWEjyWIDZb46KoHKXM/qfrerD+gMjXbCXM1gAAAAlwSFlzAAALEwAACxMBAJqcGAAAADRJREFUeJwFwYkCQCAQQMFHx26SDor8/4c2AyJEB8gW7nk4Q1Dt/+VPrGorNe/YR753+LQAHlgBpffQ4xsAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/perpetualMobile.png
/* harmony default export */ var perpetualMobile = ({"src":"/_next/static/media/perpetualMobile.79f3069c.png","height":416,"width":384,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAZlBMVEXqdLOM1LS6wI70QaTTPYnwSJn64u5MaXEv16viuFbbP5Dtd2DjeWzjSajtilLuw5rfz4nPyp3rkUCeubfKzoo24KbmlkDklkPDynDVs302s5Svn1/jpVjlvWvyslv18O7h4NLlolqnVBsjAAAAHXRSTlMFIP1dNEdqAHjPkdlSXsteQeC2fP2WX5pN6mIQvNcNY/UAAAAJcEhZcwAACxMAAAsTAQCanBgAAABASURBVHicFcVHEoAgEADBAcFlzTmD+v9PWvalEWBYBHw9xmvFZdVureKLJiU9wZVv1AMkf6Yt/N/9HBAxbRfMB1bwAsQ8okFcAAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/Aptos.png
/* harmony default export */ var Aptos = ({"src":"/_next/static/media/Aptos.5b502f26.png","height":526,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEVMaXGDmGPr68TQp2RVjTgMsIyitJXUaPCXAAAAB3RSTlMAMRq7En/EUW1sZgAAAAlwSFlzAAALEwAACxMBAJqcGAAAABdJREFUeJxjYGBgYGBhYmYE0QwMjGysAACdABd5uS+pAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/AptosXPancakeSwap.png
/* harmony default export */ var AptosXPancakeSwap = ({"src":"/_next/static/media/AptosXPancakeSwap.e487f52c.png","height":73,"width":845,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAADFBMVEX////+/vz///////8fnAAzAAAABHRSTlMzQCAKVMZxqQAAAAlwSFlzAAAsSwAALEsBpT2WqQAAABFJREFUeJxjYGBkZGRgZmIAAAAoAAk1nOkeAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/index.ts















;// CONCATENATED MODULE: ./src/views/Home/components/Banners/Styled.tsx

function Styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: -webkit-linear-gradient(#ffd800, #eb8c00);\n  font-size: 20px;\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  -webkit-text-stroke: 1px rgba(0, 0, 0, 0.5);\n  ",
        " {\n    font-size: 24px;\n  }\n  ",
        " {\n    -webkit-text-stroke: unset;\n  }\n  margin-bottom: 8px;\n"
    ]);
    Styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #ffffff;\n  background: -webkit-linear-gradient(#7645d9 0%, #452a7a 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-stroke: 6px transparent;\n  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  ",
        " {\n    margin-bottom: 16px;\n  }\n"
    ]);
    Styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 32px;\n  width: 100%;\n  max-height: max-content;\n  overflow: visible;\n  ",
        " {\n    overflow: visible;\n  }\n"
    ]);
    Styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 24px;\n  flex-direction: row;\n  justify-content: space-between;\n  max-height: 192px;\n"
    ]);
    Styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  ",
        " {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n"
    ]);
    Styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: -17px;\n  opacity: 0.9;\n  transform: translate(0, -50%);\n  top: 50%;\n\n  img {\n    height: 100%;\n    width: 500px;\n  }\n\n  ",
        " {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    right: 24px;\n    bottom: 0;\n    transform: unset;\n    opacity: 1;\n    top: unset;\n    height: 211px;\n  }\n"
    ]);
    Styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledSubheading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-6100e55a-0"
})(Styled_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-6100e55a-1"
})(Styled_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var Styled_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6100e55a-2"
})(Styled_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var Inner = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6100e55a-3"
})(Styled_templateObject3());
var LeftWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6100e55a-4"
})(Styled_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6100e55a-5"
})(Styled_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/CompetitionBanner.tsx

function CompetitionBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: -7px;\n  ",
        " {\n    bottom: 0px;\n  }\n  ",
        " {\n    bottom: 9px;\n  }\n  ",
        " {\n    bottom: -30px;\n  }\n"
    ]);
    CompetitionBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompetitionBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    CompetitionBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompetitionBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin: 10px 0 0 4px;\n  align-self: center;\n  ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    CompetitionBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var CompetitionBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b48fc70c-0"
})(CompetitionBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Header = (0,styled_components_browser_esm/* default */.ZP)(StyledHeading).withConfig({
    componentId: "sc-b48fc70c-1"
})(CompetitionBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var TradingCompetition = (0,styled_components_browser_esm/* default */.ZP)(StyledSubheading).withConfig({
    componentId: "sc-b48fc70c-2"
})(CompetitionBanner_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var CompetitionBanner = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var _useMatchBreakpoints = (0,useMatchBreakpoints/* default */.Z)(), isDesktop = _useMatchBreakpoints.isDesktop, isMobile = _useMatchBreakpoints.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: mod_white_logo,
                                    alt: "ModLogo",
                                    width: isMobile ? 68 : 112,
                                    height: isMobile ? 18 : 33
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingCompetition, {
                                    children: t("Trading Competition")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                            width: [
                                "150px",
                                "150px",
                                "auto"
                            ],
                            children: t("$120,000 in Prizes!")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            to: "/competition",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: t("Trade Now")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompetitionBanner_RightWrapper, {
                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: mod_tc_desktop,
                        alt: "CompetitionBanner",
                        width: 632,
                        height: 338,
                        placeholder: "blur"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: mod_tc_mobile,
                        alt: "CompetitionBanner",
                        width: 206,
                        height: 201,
                        placeholder: "blur"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Banners_CompetitionBanner = (/*#__PURE__*/(0,react.memo)(CompetitionBanner));

// EXTERNAL MODULE: ./src/hooks/useActiveIfoWithBlocks.ts
var useActiveIfoWithBlocks = __webpack_require__(73530);
// EXTERNAL MODULE: ./src/views/Ifos/hooks/helpers.ts
var hooks_helpers = __webpack_require__(73922);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/IFOBanner.tsx

function IFOBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	0% {transform:translateX(-100%);}\n  20% {transform:translateX(100%);}\n	100% {transform:translateX(100%);}\n"
    ]);
    IFOBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IFOBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 1px;\n  bottom: 18px;\n  ",
        " {\n    bottom: -3px;\n    right: 0;\n  }\n  ",
        " {\n    bottom: 9px;\n    right: 67px;\n  }\n  ",
        " {\n    bottom: -3px;\n    right: 67px;\n  }\n  z-index: 0;\n"
    ]);
    IFOBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function IFOBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  background-image: ",
        ";\n  background-size: cover;\n  background-repeat: no-repeat;\n  width: 35px;\n  height: 35px;\n  bottom: 35px;\n  right: 95px;\n  overflow: hidden;\n  border-radius: 50%;\n  z-index: 2;\n  ",
        " {\n    width: 60px;\n    height: 60px;\n    bottom: 25px;\n    right: 196px;\n    z-index: 2;\n  }\n  &::after {\n    content: '';\n    top: 0;\n    transform: translateX(100%);\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 1;\n    animation: ",
        " 5s infinite 1s;\n    background: -webkit-linear-gradient(\n      left,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.8) 50%,\n      rgba(128, 186, 232, 0) 99%,\n      rgba(125, 185, 232, 0) 100%\n    );\n  }\n"
    ]);
    IFOBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var IFOHeaderMobileLimitHeight = 36;
var IFOHeaderMobileLimitWidth = 335;
var shineAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(IFOBanner_templateObject());
var IFOBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fae4b323-0"
})(IFOBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var IFOIconImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fae4b323-1"
})(IFOBanner_templateObject2(), function(param) {
    var src = param.src;
    return 'url("'.concat(src, '")');
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, shineAnimation);
var IFOBanner = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var headingRef = (0,react.useRef)(null);
    var currentBlock = (0,block_hooks/* useChainCurrentBlock */.Mm)(swap_sdk_dist/* ChainId.BSC */.a_.BSC);
    var activeIfoWithBlocks = (0,useActiveIfoWithBlocks/* useActiveIfoWithBlocks */.A)();
    var _activeIfoWithBlocks_name;
    var ifoName = (_activeIfoWithBlocks_name = activeIfoWithBlocks === null || activeIfoWithBlocks === void 0 ? void 0 : activeIfoWithBlocks.name) !== null && _activeIfoWithBlocks_name !== void 0 ? _activeIfoWithBlocks_name : "XXX";
    var isIfoAlive = !!(currentBlock && activeIfoWithBlocks && activeIfoWithBlocks.endBlock > currentBlock);
    var status = isIfoAlive ? (0,hooks_helpers/* getStatus */.l)(currentBlock, activeIfoWithBlocks.startBlock, activeIfoWithBlocks.endBlock) : null;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    (0,react.useEffect)(function() {
        if (!headingRef.current) return;
        if (!isMobile) headingRef.current.style.fontSize = "";
        else if (headingRef.current.offsetHeight > IFOHeaderMobileLimitHeight || headingRef.current.offsetWidth > IFOHeaderMobileLimitWidth) {
            headingRef.current.style.fontSize = "20px";
        }
    }, [
        isMobile
    ]);
    var _activeIfoWithBlocks_id, _activeIfoWithBlocks_id1;
    return isIfoAlive && status ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubheading, {
                            children: status === "live" ? t("Live") : t("Soon")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeading, {
                            scale: "xl",
                            ref: headingRef,
                            children: [
                                ifoName,
                                " ",
                                t("IFO")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            to: "/ifo",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: t("Go to IFO")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IFOBanner_RightWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IFOIconImage, {
                            src: "/images/tokens/".concat(activeIfoWithBlocks.token.address, ".png"),
                            onError: function(event) {
                                // @ts-ignore
                                // eslint-disable-next-line no-param-reassign
                                event.target.style.display = "none";
                            }
                        }),
                        !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: IFO,
                            alt: "IFO ".concat((_activeIfoWithBlocks_id = activeIfoWithBlocks === null || activeIfoWithBlocks === void 0 ? void 0 : activeIfoWithBlocks.id) !== null && _activeIfoWithBlocks_id !== void 0 ? _activeIfoWithBlocks_id : "XXX"),
                            width: 291,
                            height: 211,
                            placeholder: "blur"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: IFOMobile,
                            alt: "IFO ".concat((_activeIfoWithBlocks_id1 = activeIfoWithBlocks === null || activeIfoWithBlocks === void 0 ? void 0 : activeIfoWithBlocks.id) !== null && _activeIfoWithBlocks_id1 !== void 0 ? _activeIfoWithBlocks_id1 : "XXX"),
                            width: 150,
                            height: 150,
                            placeholder: "blur"
                        })
                    ]
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var Banners_IFOBanner = (/*#__PURE__*/(0,react.memo)(IFOBanner));

// EXTERNAL MODULE: ../../packages/utils/getTimePeriods.ts
var getTimePeriods = __webpack_require__(20871);
// EXTERNAL MODULE: ./src/views/Lottery/components/Countdown/Timer.tsx
var Timer = __webpack_require__(85853);
// EXTERNAL MODULE: ./src/views/Lottery/hooks/useGetNextLotteryEvent.ts
var useGetNextLotteryEvent = __webpack_require__(92549);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useNextEventCountdown.ts


var useNextEventCountdown = function(nextEventTime) {
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(null), 2), secondsRemaining = _useState[0], setSecondsRemaining = _useState[1];
    var timer = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var currentSeconds = Math.floor(Date.now() / 1000);
        var secondsRemainingCalc = Math.max(nextEventTime - currentSeconds, 0);
        setSecondsRemaining(secondsRemainingCalc);
        timer.current = setInterval(function() {
            setSecondsRemaining(function(prevSecondsRemaining) {
                return Math.max(prevSecondsRemaining - 1, 0);
            });
        }, 1000);
        return function() {
            return clearInterval(timer.current);
        };
    }, [
        nextEventTime
    ]);
    return secondsRemaining;
};
/* harmony default export */ var hooks_useNextEventCountdown = (useNextEventCountdown);

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/LotteryBanner.tsx

function LotteryBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: -8px;\n  ",
        " {\n    right: 1px;\n    bottom: 1px;\n  }\n  ",
        " {\n    right: 0px;\n    bottom: 8px;\n  }\n  ",
        " {\n    right: 0px;\n    bottom: -5px;\n  }\n"
    ]);
    LotteryBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LotteryBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-bottom: 16px;\n  }\n  margin-bottom: 8px;\n  .custom-timer {\n    background: url('/images/decorations/countdownBg.png');\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    padding: 0px 10px 7px;\n    display: inline-flex;\n    white-space: nowrap;\n    transform: scale(0.88);\n    transform-origin: top left;\n  }\n"
    ]);
    LotteryBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LotteryBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  color: white;\n  ",
        " {\n    font-size: 24px;\n    &.lottery {\n      font-size: 20px;\n    }\n  }\n  ",
        " {\n    -webkit-text-stroke: unset;\n  }\n  margin-bottom: 8px;\n"
    ]);
    LotteryBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















var LotteryBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4750e143-0"
})(LotteryBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var TimerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4750e143-1"
})(LotteryBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var LotteryBanner_StyledSubheading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-4750e143-2"
})(LotteryBanner_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var isLotteryLive = function(status) {
    return status === types/* LotteryStatus.OPEN */.p3.OPEN;
};
var LotteryPrice = function() {
    var data = (0,dist/* default */.ZP)([
        "currentLottery"
    ]).data;
    var cakePriceBusd = (0,hooks/* usePriceCakeBusd */.Iu)();
    var prizeInBusd = new (bignumber_default())(data.amountCollectedInCake).times(cakePriceBusd);
    var prizeTotal = (0,formatBalance/* getBalanceNumber */.mW)(prizeInBusd);
    var t = (0,src/* useTranslation */.$G)().t;
    if (isLotteryLive(data.status)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    return null;
};
var LotteryCountDownTimer = function() {
    var data = (0,dist/* default */.ZP)([
        "currentLottery"
    ]).data;
    var endTimeAsInt = parseInt(data.endTime, 10);
    var nextEventTime = (0,useGetNextLotteryEvent/* default */.Z)(endTimeAsInt, data.status).nextEventTime;
    var secondsRemaining = hooks_useNextEventCountdown(nextEventTime);
    var _getTimePeriods = (0,getTimePeriods/* default */.Z)(secondsRemaining), days = _getTimePeriods.days, hours = _getTimePeriods.hours, minutes = _getTimePeriods.minutes, seconds = _getTimePeriods.seconds;
    if (isLotteryLive(data.status)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Timer/* default */.Z, {
        wrapperClassName: "custom-timer",
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days
    });
    return null;
};
var LotteryBanner = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var _useSWR = (0,dist/* default */.ZP)([
        "currentLottery"
    ]), data = _useSWR.data, status = _useSWR.status;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        status === types/* FetchStatus.Fetched */.iF.Fetched && isLotteryLive(data.status) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryBanner_StyledSubheading, {
                                    className: "lottery",
                                    style: {
                                        textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryPrice, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryCountDownTimer, {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubheading, {
                                    children: t("Lottery")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading, {
                                    scale: "xl",
                                    children: t("Preparing")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                            to: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Mangoswapp Feel Like A Pro"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryBanner_RightWrapper, {})
            ]
        })
    });
};
/* harmony default export */ var Banners_LotteryBanner = (/*#__PURE__*/(0,react.memo)(LotteryBanner));

;// CONCATENATED MODULE: ./src/utils/getPerpetualLanguageCode.ts
var perpetualLangs = {
    en: "en",
    ko: "ko",
    ja: "ja",
    de: "de",
    fr: "fr",
    id: "id",
    tr: "tr",
    hi: "hi",
    ru: "ru",
    vi: "vi",
    pl: "pl",
    uk: "uk-UA",
    "es-ES": "es",
    "zh-cn": "zh-CN",
    "pt-br": "pt-BR"
};
var perpLangMap = function(languageCode) {
    if (!languageCode) {
        return "en";
    }
    if (perpetualLangs[languageCode]) {
        return perpetualLangs[languageCode];
    }
    return "en";
};

;// CONCATENATED MODULE: ./src/utils/getPerpetualTheme.ts
var perpTheme = function(isDark) {
    return isDark ? "dark" : "light";
};

;// CONCATENATED MODULE: ./src/utils/getPerpetualUrl.ts



var getPerpetualUrl = function(param) {
    var chainId = param.chainId, languageCode = param.languageCode, isDark = param.isDark;
    var perpChain = chainId === swap_sdk_dist/* ChainId.ETHEREUM */.a_.ETHEREUM ? "ethereum" : "bnbchain";
    return "https://perp.pancakeswap.finance/".concat(perpLangMap(languageCode), "/futures/BTCUSDT?theme=").concat(perpTheme(isDark), "&chain=").concat(perpChain);
};

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/PerpetualBanner.tsx

function PerpetualBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  min-height: 100%;\n  right: 0;\n  bottom: 0px;\n  ",
        " {\n    bottom: 8.2px;\n  }\n  ",
        " {\n    bottom: 9px;\n  }\n  ",
        " {\n    bottom: -2px;\n  }\n"
    ]);
    PerpetualBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PerpetualBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  min-height: 44px;\n  ",
        " {\n    font-size: 40px;\n    min-height: auto;\n  }\n"
    ]);
    PerpetualBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var PerpetualBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4290a3a9-0"
})(PerpetualBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PerpetualBanner_Header = (0,styled_components_browser_esm/* default */.ZP)(StyledHeading).withConfig({
    componentId: "sc-4290a3a9-1"
})(PerpetualBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var HEADING_ONE_LINE_HEIGHT = 27;
var PerpetualBanner = function() {
    var _useTranslation = (0,src/* useTranslation */.$G)(), t = _useTranslation.t, code = _useTranslation.currentLanguage.code;
    var _useMatchBreakpoints = (0,useMatchBreakpoints/* default */.Z)(), isDesktop = _useMatchBreakpoints.isDesktop, isMobile = _useMatchBreakpoints.isMobile;
    var isDark = (0,styled_components_browser_esm/* useTheme */.Fg)().isDark;
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var perpetualUrl = (0,react.useMemo)(function() {
        return getPerpetualUrl({
            chainId: chainId,
            languageCode: code,
            isDark: isDark
        });
    }, [
        chainId,
        code,
        isDark
    ]);
    var headerRef = (0,react.useRef)(null);
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        var target = headerRef.current;
        target.style.fontSize = "" // reset
        ;
        target.style.lineHeight = "";
        if (!target || !isMobile) return;
        if (target.offsetHeight > HEADING_ONE_LINE_HEIGHT) {
            target.style.fontSize = "18px";
            target.style.lineHeight = "".concat(HEADING_ONE_LINE_HEIGHT, "px");
        }
    }, [
        isMobile,
        code
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubheading, {
                            ref: headerRef,
                            children: t("Perpetual Futures")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PerpetualBanner_Header, {
                            width: [
                                "160px",
                                "160px",
                                "auto"
                            ],
                            children: t("Up to 100\xd7 Leverage")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: "/",
                            external: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: t("Trade Now")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PerpetualBanner_RightWrapper, {})
            ]
        })
    });
};
/* harmony default export */ var Banners_PerpetualBanner = (/*#__PURE__*/(0,react.memo)(PerpetualBanner));

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useIsRenderIFOBanner.tsx



var useIsRenderIfoBanner = function() {
    var currentBlock = (0,block_hooks/* useChainCurrentBlock */.Mm)(swap_sdk_dist/* ChainId.BSC */.a_.BSC);
    var activeIfoWithBlocks = (0,useActiveIfoWithBlocks/* useActiveIfoWithBlocks */.A)();
    return !!(currentBlock && activeIfoWithBlocks && activeIfoWithBlocks.endBlock > currentBlock);
};
/* harmony default export */ var useIsRenderIFOBanner = (useIsRenderIfoBanner);

// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(42195);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useIsRenderLotteryBanner.tsx







var useIsRenderLotteryBanner = function() {
    var _useSWR = (0,dist/* default */.ZP)([
        "currentLotteryId"
    ], lottery_helpers/* fetchCurrentLotteryId */.kC, {
        refreshInterval: constants/* SLOW_INTERVAL */.KI,
        use: [
            useSWRContract/* immutableMiddleware */.NW
        ]
    }), currentLotteryId = _useSWR.data, currentLotteryIdStatus = _useSWR.status;
    var _useSWR1 = (0,dist/* default */.ZP)(currentLotteryId ? [
        "currentLottery"
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,lottery_helpers/* fetchLottery */.JE)(currentLotteryId.toString())
            ];
        });
    }), {
        refreshInterval: constants/* FAST_INTERVAL */.sR,
        use: [
            useSWRContract/* immutableMiddleware */.NW
        ]
    }), currentLotteryStatus = _useSWR1.status;
    return currentLotteryIdStatus === types/* FetchStatus.Fetched */.iF.Fetched && currentLotteryStatus === types/* FetchStatus.Fetched */.iF.Fetched;
};
/* harmony default export */ var hooks_useIsRenderLotteryBanner = (useIsRenderLotteryBanner);

// EXTERNAL MODULE: ./src/components/Menu/hooks/useCompetitionStatus.ts
var useCompetitionStatus = __webpack_require__(68443);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useIsRenderCompetitionBanner.tsx

var useIsRenderCompetitionBanner = function() {
    var competitionStatus = (0,useCompetitionStatus/* useCompetitionStatus */.U)();
    return competitionStatus !== null;
};
/* harmony default export */ var hooks_useIsRenderCompetitionBanner = (useIsRenderCompetitionBanner);

// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/OpenNew.tsx
var OpenNew = __webpack_require__(13525);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/AptosBanner.tsx

function AptosBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: -10px;\n  ",
        " {\n    right: 1px;\n    bottom: -18px;\n  }\n  ",
        " {\n    right: 0px;\n    bottom: -21px;\n  }\n"
    ]);
    AptosBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AptosBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Kanit';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 23px;\n  line-height: 110%;\n  color: #ffffff;\n  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);\n  margin-bottom: 21px;\n  margin-top: 16px;\n\n  @media screen and (max-width: 375px) {\n    font-size: 21px;\n  }\n  ",
        " {\n    font-size: 35px;\n    margin-top: 10px;\n  }\n  ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    AptosBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var AptosBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13b9eb67-0"
})(AptosBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var AptosTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13b9eb67-1"
})(AptosBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var AptosBanner = function() {
    var t = (0,src/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        style: {
            background: "linear-gradient(rgb(252,176,22) 0%,rgb(0,100,0) 100%)",
            overflow: isMobile ? "hidden" : "visible"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AptosTitle, {
                        children: t("Hello Aptos Project Teams!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        minHeight: "48px",
                        onClick: function() {
                            return window === null || window === void 0 ? void 0 : window.open("/", "_blank", "noopener noreferrer");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: "invertedContrast",
                                bold: true,
                                fontSize: "16px",
                                mr: "4px",
                                children: [
                                    "\uD83D\uDC4B ",
                                    t("Get in Touch")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNew/* default */.Z, {
                                color: "invertedContrast"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Banners_AptosBanner = (AptosBanner);

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useMultipleBannerConfig.tsx












/**
 * make your custom hook to control should render specific banner or not
 * add new campaign banner easily
 *
 * @example
 * ```ts
 *  {
 *    shouldRender: isRenderIFOBanner,
 *    banner: <IFOBanner />,
 *  },
 * ```
 */ var useMultipleBannerConfig = function() {
    var isRenderIFOBanner = useIsRenderIFOBanner();
    var isRenderLotteryBanner = hooks_useIsRenderLotteryBanner();
    var isRenderCompetitionBanner = hooks_useIsRenderCompetitionBanner();
    return (0,react.useMemo)(function() {
        var NO_SHUFFLE_BANNERS = [
            {
                shouldRender: true,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_AptosBanner, {})
            },
            {
                shouldRender: isRenderIFOBanner,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_IFOBanner, {})
            }
        ];
        var SHUFFLE_BANNERS = [
            {
                shouldRender: isRenderCompetitionBanner,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_CompetitionBanner, {})
            },
            {
                shouldRender: isRenderLotteryBanner,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_LotteryBanner, {})
            },
            {
                shouldRender: true,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_PerpetualBanner, {})
            }
        ];
        return (0,_to_consumable_array/* default */.Z)(NO_SHUFFLE_BANNERS).concat((0,_to_consumable_array/* default */.Z)(shuffle_default()(SHUFFLE_BANNERS))).filter(function(bannerConfig) {
            return bannerConfig.shouldRender;
        }).map(function(bannerConfig) {
            return bannerConfig.banner;
        });
    }, [
        isRenderIFOBanner,
        isRenderLotteryBanner,
        isRenderCompetitionBanner
    ]);
};

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/MultipleBanner.tsx


function MultipleBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 179px;\n  ",
        " {\n    height: 221px;\n  }\n  ",
        " {\n    height: 232px;\n  }\n  &::before {\n    content: '';\n    border-radius: 32px;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background: -webkit-linear-gradient(180deg,#8d034f 0%,#d90e7c 100%);\n    ",
        " {\n      top: 20px;\n      left: 20px;\n      right: 20px;\n      bottom: 20px;\n    }\n  }\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  ",
        " {\n    margin-top: ",
        ";\n    margin-bottom: 30px;\n  }\n  ",
        " {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n  ",
        ",",
        " {\n    padding-top: 0;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    MultipleBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MultipleBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: visible;\n  opacity: 0;\n  animation: ",
        " 0.3s ease-in-out 0.7s forwards;\n  .swiper-pagination {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    justify-content: center;\n    width: 108px;\n    bottom: 12px;\n    ",
        " {\n      bottom: 35px;\n    }\n    ",
        " {\n      bottom: 45px;\n    }\n    ",
        " {\n      bottom: 35px;\n    }\n  }\n  .swiper-pagination-bullet {\n    background-color: white;\n    flex-basis: 108px;\n    margin: 0 !important;\n    border-radius: 0px;\n    &:first-child {\n      border-radius: 4px 0px 0px 4px;\n    }\n    &:last-child {\n      border-radius: 0px 4px 4px 0px;\n    }\n  }\n"
    ]);
    MultipleBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}











var BannerPlaceHolder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b8086312-0"
})(MultipleBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "250px" : "0px";
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "-220px" : "0px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "190px" : "-32px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "90px" : "-32px";
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "40px" : "30px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "60px" : "-32px";
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "60px" : "30px";
});
var StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    componentId: "sc-b8086312-1"
})(MultipleBanner_templateObject1(), animationToolkit/* appearAnimation */.Oz, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var MultipleBanner = function() {
    var bannerList = useMultipleBannerConfig();
    var _useAccount = (0,wagmi_dist/* useAccount */.mA)(), account = _useAccount.address;
    var _useMatchBreakpoints = (0,useMatchBreakpoints/* default */.Z)(), isDesktop = _useMatchBreakpoints.isDesktop, isTablet = _useMatchBreakpoints.isTablet;
    var _useState = (0,_sliced_to_array/* default */.Z)((0,react.useState)(null), 2), swiperRef = _useState[0], setSwiperRef = _useState[1];
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        if (swiperRef) {
            var _swiperRef_autoplay, _swiperRef_autoplay1;
            if (bannerList.length > 1 && !((_swiperRef_autoplay = swiperRef.autoplay) === null || _swiperRef_autoplay === void 0 ? void 0 : _swiperRef_autoplay.running)) {
                var _swiperRef_autoplay2;
                (_swiperRef_autoplay2 = swiperRef.autoplay) === null || _swiperRef_autoplay2 === void 0 ? void 0 : _swiperRef_autoplay2.start();
            } else if (bannerList.length <= 1 && ((_swiperRef_autoplay1 = swiperRef.autoplay) === null || _swiperRef_autoplay1 === void 0 ? void 0 : _swiperRef_autoplay1.running)) {
                var _swiperRef_autoplay3;
                (_swiperRef_autoplay3 = swiperRef.autoplay) === null || _swiperRef_autoplay3 === void 0 ? void 0 : _swiperRef_autoplay3.stop();
            }
        }
    }, [
        bannerList,
        swiperRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerPlaceHolder, {
        style: {
            display: "none"
        },
        walletConnected: Boolean(account),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwiper, {
            onSwiper: setSwiperRef,
            modules: [
                swiper_esm/* Autoplay */.pt,
                swiper_esm/* Pagination */.tl,
                swiper_esm/* EffectFade */.xW
            ],
            spaceBetween: 50,
            observer: true,
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            speed: 500,
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true,
                disableOnInteraction: false
            },
            loop: true,
            pagination: {
                clickable: true
            },
            children: bannerList.map(function(banner, index) {
                var childKey = "Banner".concat(index);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                    style: {
                        padding: isDesktop || isTablet ? 20 : 0
                    },
                    children: banner
                }, childKey);
            })
        })
    });
};
/* harmony default export */ var Banners_MultipleBanner = (MultipleBanner);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx


function Home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n\n  ",
        " {\n    padding-top: 48px;\n  }\n"
    ]);
    Home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Home_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  padding-left: 0px;\n  padding-right: 0px;\n\n  ",
        " {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n"
    ]);
    Home_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






















var StyledHeroSection = (0,styled_components_browser_esm/* default */.ZP)(PageSection/* default */.Z).withConfig({
    componentId: "sc-896f055c-0"
})(Home_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var UserBannerWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-896f055c-1"
})(Home_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Home = function() {
    var _useTheme = (0,useTheme/* default */.ZP)(), theme = _useTheme.theme, setTheme = _useTheme.setTheme;
    var _useAccount = (0,wagmi_dist/* useAccount */.mA)(), account = _useAccount.address;
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var HomeSectionContainerStyles = {
        margin: "0",
        width: "100%",
        maxWidth: "968px"
    };
    setTheme("dark");
    var t = (0,src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            (0,jsx_runtime.jsx)((style_default()), {
                id: "4c573ea02ffaedf7",
                children: '#home-1 .page-bg{background:-webkit-linear-gradient(310.27deg,#e6fdff 0%,#f3efff 100%);background:-moz-linear-gradient(310.27deg,#e6fdff 0%,#f3efff 100%);background:-o-linear-gradient(310.27deg,#e6fdff 0%,#f3efff 100%);background:linear-gradient(139.73deg,#e6fdff 0%,#f3efff 100%)}[data-theme="dark"] #home-1 .page-bg{background:-webkit-radial-gradient(50%50%,103.12%50%,#21193a 0%,#191326 100%);background:-moz-radial-gradient(50%50%,103.12%50%,#21193a 0%,#191326 100%);background:-o-radial-gradient(50%50%,103.12%50%,#21193a 0%,#191326 100%);background:radial-gradient(103.12%50%at 50%50%,#21193a 0%,#191326 100%)}#home-2 .page-bg{background:-webkit-linear-gradient(top,#fff 22%,#ebecca 100%);background:-moz-linear-gradient(top,#fff 22%,#ebecca 100%);background:-o-linear-gradient(top,#fff 22%,#ebecca 100%);background:linear-gradient(180deg,#fff 22%,#ebecca 100%)}[data-theme="dark"] #home-2 .page-bg{background:-webkit-linear-gradient(top,#09070c 22%,#201335 100%);background:-moz-linear-gradient(top,#09070c 22%,#201335 100%);background:-o-linear-gradient(top,#09070c 22%,#201335 100%);background:linear-gradient(180deg,#09070c 22%,#201335 100%)}#home-3 .page-bg{background:-webkit-linear-gradient(top,#6fb6f1 0%,#eaf2f6 100%);background:-moz-linear-gradient(top,#6fb6f1 0%,#eaf2f6 100%);background:-o-linear-gradient(top,#6fb6f1 0%,#eaf2f6 100%);background:linear-gradient(180deg,#6fb6f1 0%,#eaf2f6 100%)}[data-theme="dark"] #home-3 .page-bg{background:-webkit-linear-gradient(top,#0b4576 0%,#091115 100%);background:-moz-linear-gradient(top,#0b4576 0%,#091115 100%);background:-o-linear-gradient(top,#0b4576 0%,#091115 100%);background:linear-gradient(180deg,#0b4576 0%,#091115 100%)}#home-4 .inner-wedge svg{fill:#d8cbed}[data-theme="dark"] #home-4 .inner-wedge svg{fill:#201335}'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroSection, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "home-1"
                },
                index: 2,
                hasCurvedDivider: false,
                children: [
                    account && chainId === swap_sdk_dist/* ChainId.BSC */.a_.BSC && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserBannerWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserBanner, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_MultipleBanner, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "home-2"
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: theme.colors.background,
                containerProps: {
                    id: "home-4"
                },
                index: 2,
                hasCurvedDivider: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OuterWedgeWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerWedgeWrapper, {
                            top: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WedgeTopLeft, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, swapSectionData(t)))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: theme.colors.gradientCardHeader,
                index: 2,
                hasCurvedDivider: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OuterWedgeWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerWedgeWrapper, {
                            width: "150%",
                            top: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WedgeTopRight, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, earnSectionData(t))),
                    chainId === swap_sdk_dist/* ChainId.BSC */.a_.BSC && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FarmsPoolsRow, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                style: {
                    display: "none"
                },
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                containerProps: {
                    id: "home-3"
                },
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WinSection, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: theme.colors.background,
                index: 2,
                hasCurvedDivider: false,
                style: {
                    display: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SalesSection, (0,src_object_spread/* default */.Z)({}, cakeSectionData(t))),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CakeDataRow, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                background: "linear-gradient(rgb(252,176,22) 0%,rgb(0,100,0) 100%)",
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, {})
            })
        ]
    });
};
/* harmony default export */ var views_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
        value: {
            fallback: {
                totalTx30Days: totalTx30Days,
                addressCount30Days: addressCount30Days,
                tvl: tvl
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {})
    });
};
IndexPage.chains = [];
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);


/***/ }),

/***/ 71446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87016);
/* harmony import */ var hooks_useTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84252);







var ColoredWordHeading = function(_param) {
    var text = _param.text, firstColor = _param.firstColor, _param_mb = _param.mb, mb = _param_mb === void 0 ? "24px" : _param_mb, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "firstColor",
        "mb"
    ]);
    var theme = (0,hooks_useTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)().theme;
    var _useMemo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var split = text.split(" ");
        var first = split[0];
        var remaining = split.slice(1).join(" ");
        return {
            firstWord: first,
            remainingWords: remaining
        };
    }, [
        text
    ]), firstWord = _useMemo.firstWord, remainingWords = _useMemo.remainingWords;
    var _theme_colors_firstColor;
    var displayedColor = (_theme_colors_firstColor = theme.colors[firstColor]) !== null && _theme_colors_firstColor !== void 0 ? _theme_colors_firstColor : theme.colors.secondary;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        scale: "xl",
        mb: mb
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                style: {
                    color: displayedColor
                },
                children: [
                    firstWord,
                    " "
                ]
            }),
            remainingWords
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ColoredWordHeading);


/***/ }),

/***/ 2076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ SlideSvgDark; },
/* harmony export */   "s": function() { return /* binding */ SlideSvgLight; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6816);




var SlideSvgLight = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 1660 339"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M804 167.023C520.5 167.023 267.5 290.522 0 304.5V339H1660V0.5C1358.83 0.5 1104 167.023 804 167.023Z",
                fill: "url(#paint0_linear_light)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "paint0_linear_light",
                    x1: "830",
                    y1: "84",
                    x2: "830",
                    y2: "339",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            stopColor: "white",
                            stopOpacity: "0.48"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.566389",
                            stopColor: "white",
                            stopOpacity: "0.35"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "1",
                            stopColor: "white"
                        })
                    ]
                })
            })
        ]
    }));
};
var SlideSvgDark = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 1660 339"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M804 166.523C520.5 166.523 267.5 290.022 0 304V338.5H1660V0C1358.83 0 1104 166.523 804 166.523Z",
                fill: "url(#paint0_linear_dark)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "paint0_linear_dark",
                    x1: "830",
                    y1: "83.5",
                    x2: "830",
                    y2: "338.5",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            stopColor: "#08060B",
                            stopOpacity: "0.2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.545554",
                            stopColor: "#08060B",
                            stopOpacity: "0.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "1",
                            stopColor: "#08060B"
                        })
                    ]
                })
            })
        ]
    }));
};


/***/ }),

/***/ 85853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3411);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33080);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87016);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  div:last-of-type {\n    margin-right: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var StyledTimerFlex = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a9e55172-0"
})(_templateObject(), function(param) {
    var theme = param.theme, showTooltip = param.showTooltip;
    return showTooltip ? " border-bottom: 1px dashed ".concat(theme.colors.textSubtle, ";") : "";
});
var StyledTimerText = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-a9e55172-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gradientGold;
});
var Wrapper = function(param) {
    var minutes = param.minutes, hours = param.hours, days = param.days, seconds = param.seconds, wrapperClassName = param.wrapperClassName;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledTimerFlex, {
        alignItems: "flex-end",
        className: wrapperClassName,
        children: [
            Boolean(days) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTimerText, {
                        mb: "-4px",
                        scale: "xl",
                        mr: "4px",
                        children: days
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTimerText, {
                        mr: "12px",
                        children: t("d")
                    })
                ]
            }),
            Boolean(hours) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTimerText, {
                        mb: "-4px",
                        scale: "xl",
                        mr: "4px",
                        children: hours
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTimerText, {
                        mr: "12px",
                        children: t("h")
                    })
                ]
            }),
            Boolean(minutes) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTimerText, {
                        mb: "-4px",
                        scale: "xl",
                        mr: "4px",
                        children: minutes
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTimerText, {
                        mr: "12px",
                        children: t("m")
                    })
                ]
            }),
            Boolean(seconds) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTimerText, {
                        mb: "-4px",
                        scale: "xl",
                        mr: "4px",
                        children: seconds
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTimerText, {
                        mr: "12px",
                        children: t("s")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Wrapper);


/***/ }),

/***/ 92549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var config_constants_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57647);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73921);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



var vrfRequestTime = 180 // 3 mins
;
var secondsBetweenRounds = 300 // 5 mins
;
var transactionResolvingBuffer = 30 // Delay countdown by 30s to ensure contract transactions have been calculated and broadcast
;
var useGetNextLotteryEvent = function(endTime, status) {
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().t;
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        // Current lottery is active
        if (status === config_constants_types__WEBPACK_IMPORTED_MODULE_0__/* .LotteryStatus.OPEN */ .p3.OPEN) {
            return {
                nextEventTime: endTime + transactionResolvingBuffer,
                preCountdownText: null,
                postCountdownText: t("until the draw")
            };
        }
        // Current lottery has finished but not yet claimable
        if (status === config_constants_types__WEBPACK_IMPORTED_MODULE_0__/* .LotteryStatus.CLOSE */ .p3.CLOSE) {
            return {
                nextEventTime: endTime + transactionResolvingBuffer + vrfRequestTime,
                preCountdownText: t("Winners announced in"),
                postCountdownText: null
            };
        }
        // Current lottery claimable. Next lottery has not yet started
        if (status === config_constants_types__WEBPACK_IMPORTED_MODULE_0__/* .LotteryStatus.CLAIMABLE */ .p3.CLAIMABLE) {
            return {
                nextEventTime: endTime + transactionResolvingBuffer + secondsBetweenRounds,
                preCountdownText: t("Tickets on sale in"),
                postCountdownText: null
            };
        }
        return {
            nextEventTime: null,
            preCountdownText: null,
            postCountdownText: null
        };
    }, [
        endTime,
        status,
        t
    ]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetNextLotteryEvent);


/***/ }),

/***/ 80751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Card_Card; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(3411);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(78545);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(5406);
;// CONCATENATED MODULE: ../../packages/uikit/src/components/Card/StyledCard.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 3s ease infinite;\n      background-size: 400% 400%;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  position: relative;\n\n  ",
        "\n\n  padding: 1px 1px 3px 1px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  overflow: ",
        ";\n  background: ",
        ";\n  border-radius: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var PromotedGradient = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
/**
 * Priority: Warning --> Success --> Active
 */ var getBorderColor = function(param) {
    var isActive = param.isActive, isSuccess = param.isSuccess, isWarning = param.isWarning, borderBackground = param.borderBackground, theme = param.theme;
    if (borderBackground) {
        return borderBackground;
    }
    if (isWarning) {
        return theme.colors.warning;
    }
    if (isSuccess) {
        return theme.colors.success;
    }
    if (isActive) {
        return "linear-gradient(180deg, ".concat(theme.colors.primaryBright, ", ").concat(theme.colors.secondary, ")");
    }
    return theme.colors.cardBorder;
};
var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eecfaa46-0"
})(_templateObject2(), getBorderColor, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme, isDisabled = param.isDisabled;
    return theme.colors[isDisabled ? "textDisabled" : "text"];
}, function(param) {
    var isActive = param.isActive;
    return isActive && (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), PromotedGradient);
}, index_esm/* space */.Dh);
var StyledCardInner = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.ZP).withConfig({
    componentId: "sc-eecfaa46-1"
})(_templateObject3(), function(param) {
    var hasCustomBorder = param.hasCustomBorder;
    return hasCustomBorder ? "initial" : "inherit";
}, function(param) {
    var theme = param.theme, background = param.background;
    return background !== null && background !== void 0 ? background : theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
});
StyledCard.defaultProps = {
    isActive: false,
    isSuccess: false,
    isWarning: false,
    isDisabled: false
};

;// CONCATENATED MODULE: ../../packages/uikit/src/components/Card/Card.tsx






var Card = function(_param) {
    var ribbon = _param.ribbon, children = _param.children, background = _param.background, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ribbon",
        "children",
        "background"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardInner, {
            background: background,
            hasCustomBorder: !!props.borderBackground,
            children: [
                ribbon,
                children
            ]
        })
    }));
};
/* harmony default export */ var Card_Card = (Card);


/***/ }),

/***/ 11335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6816);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5 7C5 6.44772 4.55228 6 4 6C3.44772 6 3 6.44772 3 7V18C3 19.1046 3.89543 20 5 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18H5V7Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19 17H7C6.44772 17 6 16.5523 6 16V12C6 11.4477 6.44772 11 7 11H10V10C10 9.44772 10.4477 9 11 9H14V7C14 6.44772 14.4477 6 15 6H19C19.5523 6 20 6.44772 20 7V16C20 16.5523 19.5523 17 19 17ZM16 8H18V15H16V8ZM12 15H14V11H12V15ZM10 13H8V15H10V13Z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 17163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6816);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V17C0 17.5523 0.447715 18 1 18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H23C23.5523 18 24 17.5523 24 17V16.43ZM16.24 13.65C15.07 13.13 13.63 12.75 12 12.75C10.37 12.75 8.93 13.14 7.76 13.65C6.68 14.13 6 15.21 6 16.39V17C6 17.5523 6.44772 18 7 18H17C17.5523 18 18 17.5523 18 17V16.39C18 15.21 17.32 14.13 16.24 13.65ZM8.07 16C8.16 15.77 8.2 15.61 8.98 15.31C9.95 14.93 10.97 14.75 12 14.75C13.03 14.75 14.05 14.93 15.02 15.31C15.79 15.61 15.83 15.77 15.93 16H8.07ZM12 8C12.55 8 13 8.45 13 9C13 9.55 12.55 10 12 10C11.45 10 11 9.55 11 9C11 8.45 11.45 8 12 8ZM12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 16775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3411);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6816);






var Icon = function(props) {
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    var primaryColor = theme.isDark ? "#3C3742" : "#e9eaeb";
    var secondaryColor = theme.isDark ? "#666171" : "#bdc2c4";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 32 32"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z",
                fill: primaryColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                id: "A",
                "mask-type": "alpha",
                maskUnits: "userSpaceOnUse",
                x: "0",
                y: "0",
                width: "32",
                height: "32",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16z",
                    fill: "#c4c4c4"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                mask: "url(#A)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M25.128 16.436c0 3.115-4.133 5.641-9.231 5.641s-9.231-2.526-9.231-5.641V15h18.461v1.436zm2.205 13.806c0-3.815-5.074-6.908-11.333-6.908S4.667 26.426 4.667 30.242V32h22.667v-1.759z",
                        fill: secondaryColor
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M10.234 5.601C9.942 4.264 10.96 3 12.328 3c1.184 0 2.143.959 2.143 2.143v3.873l1.427-.067c.589 0 1.166.034 1.724.098V5.143c0-1.184.959-2.143 2.143-2.143 1.368 0 2.386 1.264 2.093 2.601l-.931 4.258c2.529 1.006 4.201 2.749 4.201 4.731 0 3.115-4.133 5.641-9.231 5.641s-9.231-2.526-9.231-5.641c0-2.053 1.794-3.849 4.476-4.836l-.908-4.153z",
                        fill: secondaryColor
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                        cx: "12.308",
                        cy: "14.846",
                        rx: "1.026",
                        ry: "1.538",
                        fill: primaryColor
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ellipse", {
                        cx: "19.385",
                        cy: "14.846",
                        rx: "1.026",
                        ry: "1.538",
                        fill: primaryColor
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 15756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6816);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M3.18731 5.68438C2.44993 5.52604 2.44993 4.47393 3.18731 4.31559L5.3203 3.85755C5.58957 3.79973 5.79991 3.58939 5.85774 3.32012L6.31577 1.18713C6.47411 0.449748 7.52622 0.449751 7.68457 1.18713L8.1426 3.32012C8.20042 3.58939 8.41076 3.79973 8.68003 3.85755L10.813 4.31559C11.5504 4.47393 11.5504 5.52604 10.813 5.68438L8.68003 6.14241C8.41076 6.20024 8.20042 6.41058 8.1426 6.67985L7.68457 8.81284C7.52622 9.55022 6.47411 9.55022 6.31577 8.81284L5.85774 6.67985C5.79991 6.41058 5.58957 6.20024 5.3203 6.14241L3.18731 5.68438Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 2.99998C15.866 2.99998 19 6.13399 19 9.99998C19 13.866 15.866 17 12 17C8.13401 17 5 13.866 5 9.99998C5 9.4477 4.55228 8.99998 4 8.99998C3.44772 8.99998 3 9.4477 3 9.99998C3 12.8894 4.36163 15.4608 6.47822 17.1075L5.58579 18C5.21071 18.3751 5 18.8838 5 19.4142V21.5C5 22.3284 5.67157 23 6.5 23H17.5C18.3284 23 19 22.3284 19 21.5V19.4142C19 18.8838 18.7893 18.3751 18.4142 18L17.5218 17.1075C19.6384 15.4608 21 12.8894 21 9.99998C21 5.02942 16.9706 0.999985 12 0.999985C11.4477 0.999985 11 1.4477 11 1.99998C11 2.55227 11.4477 2.99998 12 2.99998ZM12 19C10.6564 19 9.38156 18.7056 8.23649 18.1777L7 19.4142L7 21H17V19.4142L15.7635 18.1777C14.6184 18.7056 13.3436 19 12 19Z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 61150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6816);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.4144 13.4824L9.36944 5.52736L10.0765 6.23446C10.3694 6.52736 10.8443 6.52736 11.1372 6.23446C11.4301 5.94157 11.4301 5.4667 11.1372 5.1738L10.4301 4.4667L12.7281 2.16869C13.5092 1.38764 14.7755 1.38764 15.5565 2.16869L16.6173 3.22943C16.8125 3.42465 16.8125 3.74115 16.6173 3.93637C15.641 4.91268 15.641 6.49559 16.6173 7.4719C17.5936 8.44821 19.1765 8.44821 20.1528 7.4719C20.348 7.27669 20.6645 7.27669 20.8597 7.4719L21.9205 8.53265C22.7015 9.3137 22.7015 10.58 21.9205 11.3611L19.6224 13.6592L18.9153 12.9521C18.6224 12.6592 18.1475 12.6592 17.8546 12.9521C17.5617 13.245 17.5617 13.7198 17.8546 14.0127L18.5617 14.7198L10.6068 22.6748C9.82574 23.4558 8.55941 23.4558 7.77836 22.6748L6.7177 21.6141C6.52244 21.4189 6.52244 21.1023 6.7177 20.907C7.69401 19.9307 7.69401 18.3478 6.7177 17.3715C5.74139 16.3952 4.15848 16.3952 3.18217 17.3715C2.9869 17.5667 2.67032 17.5667 2.47506 17.3715L1.4144 16.3108C0.633351 15.5298 0.633351 14.2634 1.4144 13.4824ZM13.2584 7.29521C12.9655 7.00232 12.4907 7.00232 12.1978 7.29521C11.9049 7.5881 11.9049 8.06298 12.1978 8.35587L12.9049 9.06298C13.1978 9.35587 13.6727 9.35587 13.9655 9.06298C14.2584 8.77009 14.2584 8.29521 13.9655 8.00232L13.2584 7.29521ZM15.0262 10.1236C15.3191 9.83075 15.794 9.83074 16.0869 10.1236L16.794 10.8307C17.0869 11.1236 17.0869 11.5985 16.794 11.8914C16.5011 12.1843 16.0262 12.1843 15.7333 11.8914L15.0262 11.1843C14.7333 10.8914 14.7333 10.4165 15.0262 10.1236Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6816);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 6.49999C14.76 6.49999 17 8.73999 17 11.5C17 12.01 16.9 12.5 16.76 12.96L19.82 16.02C21.21 14.79 22.31 13.25 23 11.49C21.27 7.10999 17 3.99999 12 3.99999C10.73 3.99999 9.51 4.19999 8.36 4.56999L10.53 6.73999C11 6.59999 11.49 6.49999 12 6.49999ZM2.71 3.15999C2.32 3.54999 2.32 4.17999 2.71 4.56999L4.68 6.53999C3.06 7.82999 1.77 9.52999 1 11.5C2.73 15.89 7 19 12 19C13.52 19 14.97 18.7 16.31 18.18L19.03 20.9C19.42 21.29 20.05 21.29 20.44 20.9C20.83 20.51 20.83 19.88 20.44 19.49L4.13 3.15999C3.74 2.76999 3.1 2.76999 2.71 3.15999ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 10.73 7.18 9.99999 7.49 9.35999L9.06 10.93C9.03 11.11 9 11.3 9 11.5C9 13.16 10.34 14.5 12 14.5C12.2 14.5 12.38 14.47 12.57 14.43L14.14 16C13.49 16.32 12.77 16.5 12 16.5ZM14.97 11.17C14.82 9.76999 13.72 8.67999 12.33 8.52999L14.97 11.17Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 60454:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6816);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5ZM12 8.5C10.34 8.5 9 9.84 9 11.5C9 13.16 10.34 14.5 12 14.5C13.66 14.5 15 13.16 15 11.5C15 9.84 13.66 8.5 12 8.5Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 20871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ DAY_IN_SECONDS; }
/* harmony export */ });
var MINUTE_IN_SECONDS = 60;
var HOUR_IN_SECONDS = 3600;
var DAY_IN_SECONDS = 86400;
var MONTH_IN_SECONDS = 2629800;
var YEAR_IN_SECONDS = 31557600;
/**
 * Format number of seconds into year, month, day, hour, minute, seconds
 *
 * @param seconds
 */ var getTimePeriods = function(seconds) {
    var delta = Math.abs(seconds);
    var timeLeft = {
        years: 0,
        months: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    };
    if (delta >= YEAR_IN_SECONDS) {
        timeLeft.years = Math.floor(delta / YEAR_IN_SECONDS);
        delta -= timeLeft.years * YEAR_IN_SECONDS;
    }
    if (delta >= MONTH_IN_SECONDS) {
        timeLeft.months = Math.floor(delta / MONTH_IN_SECONDS);
        delta -= timeLeft.months * MONTH_IN_SECONDS;
    }
    if (delta >= DAY_IN_SECONDS) {
        timeLeft.days = Math.floor(delta / DAY_IN_SECONDS);
        delta -= timeLeft.days * DAY_IN_SECONDS;
    }
    if (delta >= HOUR_IN_SECONDS) {
        timeLeft.hours = Math.floor(delta / HOUR_IN_SECONDS);
        delta -= timeLeft.hours * HOUR_IN_SECONDS;
    }
    if (delta >= MINUTE_IN_SECONDS) {
        timeLeft.minutes = Math.floor(delta / MINUTE_IN_SECONDS);
        delta -= timeLeft.minutes * MINUTE_IN_SECONDS;
    }
    timeLeft.seconds = delta;
    return timeLeft;
};
/* harmony default export */ __webpack_exports__["Z"] = (getTimePeriods);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7506,8824,6511,8318,1226,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);